// Auto-generated by scratchpad/gen-team-colors.mjs +
// scratchpad/emit-team-colors.mjs — do not hand-edit.

const NFL_COLORS = {
  "ARI": "#a40227",
  "ATL": "#a71930",
  "Arizona Cardinals": "#a40227",
  "Atlanta Falcons": "#a71930",
  "BAL": "#29126f",
  "BUF": "#00338d",
  "Baltimore Ravens": "#29126f",
  "Buffalo Bills": "#00338d",
  "CAR": "#0085ca",
  "CHI": "#0b1c3a",
  "CIN": "#fb4f14",
  "CLE": "#472a08",
  "Carolina Panthers": "#0085ca",
  "Chicago Bears": "#0b1c3a",
  "Cincinnati Bengals": "#fb4f14",
  "Cleveland Browns": "#472a08",
  "DAL": "#002a5c",
  "DEN": "#0a2343",
  "DET": "#0076b6",
  "Dallas Cowboys": "#002a5c",
  "Denver Broncos": "#0a2343",
  "Detroit Lions": "#0076b6",
  "GB": "#204e32",
  "Green Bay Packers": "#204e32",
  "HOU": "#021018",
  "Houston Texans": "#021018",
  "IND": "#003b75",
  "Indianapolis Colts": "#003b75",
  "JAX": "#007487",
  "Jacksonville Jaguars": "#007487",
  "KC": "#e31837",
  "Kansas City Chiefs": "#e31837",
  "LAC": "#0080c6",
  "LAR": "#003594",
  "LV": "#000000",
  "Las Vegas Raiders": "#000000",
  "Los Angeles Chargers": "#0080c6",
  "Los Angeles Rams": "#003594",
  "MIA": "#008e97",
  "MIN": "#4f2683",
  "Miami Dolphins": "#008e97",
  "Minnesota Vikings": "#4f2683",
  "NE": "#002a5c",
  "NO": "#d3bc8d",
  "NYG": "#003c7f",
  "NYJ": "#115740",
  "New England Patriots": "#002a5c",
  "New Orleans Saints": "#d3bc8d",
  "New York Giants": "#003c7f",
  "New York Jets": "#115740",
  "PHI": "#06424d",
  "PIT": "#000000",
  "Philadelphia Eagles": "#06424d",
  "Pittsburgh Steelers": "#000000",
  "SEA": "#002a5c",
  "SF": "#aa0000",
  "San Francisco 49ers": "#aa0000",
  "Seattle Seahawks": "#002a5c",
  "TB": "#bd1c36",
  "TEN": "#4495d2",
  "Tampa Bay Buccaneers": "#bd1c36",
  "Tennessee Titans": "#4495d2",
  "WSH": "#5a1414",
  // ESPN says WSH, Sleeper says WAS — and nfl_players.team is populated from
  // Sleeper, so the fantasy/salary-cap player modal asks for "WAS". Without
  // this alias every Washington player lost the team-colour hero backdrop
  // while the other 31 teams had one.
  "WAS": "#5a1414",
  "Washington Commanders": "#5a1414",
}

const NBA_COLORS = {
  "ATL": "#c8102e",
  "Atlanta Hawks": "#c8102e",
  "BKN": "#000000",
  "BOS": "#008348",
  "Boston Celtics": "#008348",
  "Brooklyn Nets": "#000000",
  "CHA": "#008ca8",
  "CHI": "#ce1141",
  "CLE": "#860038",
  "Charlotte Hornets": "#008ca8",
  "Chicago Bulls": "#ce1141",
  "Cleveland Cavaliers": "#860038",
  "DAL": "#0064b1",
  "DEN": "#0e2240",
  "DET": "#1d428a",
  "Dallas Mavericks": "#0064b1",
  "Denver Nuggets": "#0e2240",
  "Detroit Pistons": "#1d428a",
  "GS": "#fdb927",
  "Golden State Warriors": "#fdb927",
  "HOU": "#ce1141",
  "Houston Rockets": "#ce1141",
  "IND": "#0c2340",
  "Indiana Pacers": "#0c2340",
  "LA Clippers": "#12173f",
  // ESPN and our own survivor picks both write the long form; the map only
  // had the short one, so Clippers picks came back colourless.
  "Los Angeles Clippers": "#12173f",
  "LAC": "#12173f",
  "LAL": "#552583",
  "Los Angeles Lakers": "#552583",
  "MEM": "#5d76a9",
  "MIA": "#98002e",
  "MIL": "#00471b",
  "MIN": "#266092",
  "Memphis Grizzlies": "#5d76a9",
  "Miami Heat": "#98002e",
  "Milwaukee Bucks": "#00471b",
  "Minnesota Timberwolves": "#266092",
  "NO": "#0a2240",
  "NY": "#1d428a",
  "New Orleans Pelicans": "#0a2240",
  "New York Knicks": "#1d428a",
  "OKC": "#007ac1",
  "ORL": "#0150b5",
  "Oklahoma City Thunder": "#007ac1",
  "Orlando Magic": "#0150b5",
  "PHI": "#1d428a",
  "PHX": "#29127a",
  "POR": "#e03a3e",
  "Philadelphia 76ers": "#1d428a",
  "Phoenix Suns": "#29127a",
  "Portland Trail Blazers": "#e03a3e",
  "SA": "#000000",
  "SAC": "#5a2d81",
  "Sacramento Kings": "#5a2d81",
  "San Antonio Spurs": "#000000",
  "TOR": "#d91244",
  "Toronto Raptors": "#d91244",
  "UTAH": "#4e008e",
  "Utah Jazz": "#4e008e",
  "WSH": "#e31837",
  "Washington Wizards": "#e31837",
}

const WNBA_COLORS = {
  "ATL": "#e31837",
  "Atlanta Dream": "#e31837",
  "CHI": "#5091cd",
  "CON": "#f05023",
  "Chicago Sky": "#5091cd",
  "Connecticut Sun": "#f05023",
  "DAL": "#002b5c",
  "Dallas Wings": "#002b5c",
  "GS": "#b38fcf",
  "Golden State Valkyries": "#b38fcf",
  "IND": "#002d62",
  "Indiana Fever": "#002d62",
  "LA": "#552583",
  "LV": "#a7a8aa",
  "Las Vegas Aces": "#a7a8aa",
  "Los Angeles Sparks": "#552583",
  "MIN": "#266092",
  "Minnesota Lynx": "#266092",
  "NY": "#86cebc",
  "New York Liberty": "#86cebc",
  "PHX": "#3c286e",
  "POR": "#cee5eb",
  "Phoenix Mercury": "#3c286e",
  "Portland Fire": "#cee5eb",
  "SEA": "#2c5235",
  "Seattle Storm": "#2c5235",
  "TOR": "#33476d",
  "Toronto Tempo": "#33476d",
  "WSH": "#e03a3e",
  "Washington Mystics": "#e03a3e",
}

const MLB_COLORS = {
  "ARI": "#aa182c",
  "ATH": "#003831",
  "ATL": "#0c2340",
  "Arizona Diamondbacks": "#aa182c",
  "Athletics": "#003831",
  "Atlanta Braves": "#0c2340",
  "BAL": "#df4601",
  "BOS": "#0d2b56",
  "Baltimore Orioles": "#df4601",
  "Boston Red Sox": "#0d2b56",
  "CHC": "#0e3386",
  "CHW": "#000000",
  "CIN": "#c6011f",
  "CLE": "#002b5c",
  "COL": "#33006f",
  "Chicago Cubs": "#0e3386",
  "Chicago White Sox": "#000000",
  "Cincinnati Reds": "#c6011f",
  "Cleveland Guardians": "#002b5c",
  "Colorado Rockies": "#33006f",
  "DET": "#0a2240",
  "Detroit Tigers": "#0a2240",
  "HOU": "#002d62",
  "Houston Astros": "#002d62",
  "KC": "#004687",
  "Kansas City Royals": "#004687",
  "LAA": "#ba0021",
  "LAD": "#005a9c",
  "Los Angeles Angels": "#ba0021",
  "Los Angeles Dodgers": "#005a9c",
  "MIA": "#00a3e0",
  "MIL": "#13294b",
  "MIN": "#031f40",
  "Miami Marlins": "#00a3e0",
  "Milwaukee Brewers": "#13294b",
  "Minnesota Twins": "#031f40",
  "NYM": "#002d72",
  "NYY": "#132448",
  "New York Mets": "#002d72",
  "New York Yankees": "#132448",
  "PHI": "#e81828",
  "PIT": "#000000",
  "Philadelphia Phillies": "#e81828",
  "Pittsburgh Pirates": "#000000",
  "SD": "#2f241d",
  "SEA": "#005c5c",
  "SF": "#000000",
  "STL": "#be0a14",
  "San Diego Padres": "#2f241d",
  "San Francisco Giants": "#000000",
  "Seattle Mariners": "#005c5c",
  "St. Louis Cardinals": "#be0a14",
  "TB": "#092c5c",
  "TEX": "#003278",
  "TOR": "#134a8e",
  "Tampa Bay Rays": "#092c5c",
  "Texas Rangers": "#003278",
  "Toronto Blue Jays": "#134a8e",
  "WSH": "#ab0003",
  "Washington Nationals": "#ab0003",
}

const NHL_COLORS = {
  "ANA": "#fc4c02",
  "Anaheim Ducks": "#fc4c02",
  "BOS": "#231f20",
  "BUF": "#00468b",
  "Boston Bruins": "#231f20",
  "Buffalo Sabres": "#00468b",
  "CAR": "#e30426",
  "CBJ": "#002d62",
  "CGY": "#dd1a32",
  "CHI": "#e31937",
  "COL": "#860038",
  "Calgary Flames": "#dd1a32",
  "Carolina Hurricanes": "#e30426",
  "Chicago Blackhawks": "#e31937",
  "Colorado Avalanche": "#860038",
  "Columbus Blue Jackets": "#002d62",
  "DAL": "#20864c",
  "DET": "#e30526",
  "Dallas Stars": "#20864c",
  "Detroit Red Wings": "#e30526",
  "EDM": "#00205b",
  "Edmonton Oilers": "#00205b",
  "FLA": "#e51937",
  "Florida Panthers": "#e51937",
  "LA": "#121212",
  "Los Angeles Kings": "#121212",
  "MIN": "#124734",
  "MTL": "#c41230",
  "Minnesota Wild": "#124734",
  "Montreal Canadiens": "#c41230",
  "NJ": "#e30b2b",
  "NSH": "#fdba31",
  "NYI": "#00529b",
  "NYR": "#0056ae",
  "Nashville Predators": "#fdba31",
  "New Jersey Devils": "#e30b2b",
  "New York Islanders": "#00529b",
  "New York Rangers": "#0056ae",
  "OTT": "#dd1a32",
  "Ottawa Senators": "#dd1a32",
  "PHI": "#fe5823",
  "PIT": "#000000",
  "Philadelphia Flyers": "#fe5823",
  "Pittsburgh Penguins": "#000000",
  "SEA": "#000d33",
  "SJ": "#00788a",
  "STL": "#0070b9",
  "San Jose Sharks": "#00788a",
  "Seattle Kraken": "#000d33",
  "St. Louis Blues": "#0070b9",
  "TB": "#003e7e",
  "TOR": "#003e7e",
  "Tampa Bay Lightning": "#003e7e",
  "Toronto Maple Leafs": "#003e7e",
  "UTAH": "#000000",
  "Utah Mammoth": "#000000",
  "VAN": "#003e7e",
  "VGK": "#344043",
  "Vancouver Canucks": "#003e7e",
  "Vegas Golden Knights": "#344043",
  "WPG": "#002d62",
  "WSH": "#d71830",
  "Washington Capitals": "#d71830",
  "Winnipeg Jets": "#002d62",
}

const MLS_COLORS = {
  "ATL": "#9d2235",
  "ATX": "#00b140",
  "Atlanta United FC": "#9d2235",
  "Austin FC": "#00b140",
  "CF Montréal": "#003da6",
  "CHI": "#7ccdef",
  "CIN": "#003087",
  "CLB": "#000000",
  "CLT": "#0085ca",
  "COL": "#8a2432",
  "Charlotte FC": "#0085ca",
  "Chicago Fire FC": "#7ccdef",
  "Colorado Rapids": "#8a2432",
  "Columbus Crew": "#000000",
  "Columbus Crew SC": "#000000",
  "D.C. United": "#000000",
  "DAL": "#c6093b",
  "DC": "#000000",
  "FC Cincinnati": "#003087",
  "FC Dallas": "#c6093b",
  "HOU": "#ff6b00",
  "Houston Dynamo FC": "#ff6b00",
  "Inter Miami CF": "#231f20",
  "LA": "#00235d",
  "LA Galaxy": "#00235d",
  "LAFC": "#000000",
  "MIA": "#231f20",
  "MIN": "#000000",
  "MTL": "#003da6",
  "Minnesota United FC": "#000000",
  "NE": "#022166",
  "NSH": "#ece83a",
  "NYC": "#9fd2ff",
  "Nashville SC": "#ece83a",
  "New England Revolution": "#022166",
  "New York City FC": "#9fd2ff",
  "ORL": "#60269e",
  "Orlando City SC": "#60269e",
  "PHI": "#051f31",
  "POR": "#2c5234",
  "Philadelphia Union": "#051f31",
  "Portland Timbers": "#2c5234",
  "RBNY": "#ba0c2f",
  "RSL": "#a32035",
  "Real Salt Lake": "#a32035",
  "Red Bull New York": "#ba0c2f",
  "SD": "#697a7c",
  "SEA": "#2dc84d",
  "SJ": "#003da6",
  "SKC": "#a7c6ed",
  "STL": "#ec1458",
  "San Diego FC": "#697a7c",
  "San Jose Earthquakes": "#003da6",
  "Seattle Sounders FC": "#2dc84d",
  "Sporting Kansas City": "#a7c6ed",
  "St. Louis CITY SC": "#ec1458",
  "TOR": "#aa182c",
  "Toronto FC": "#aa182c",
  "VAN": "#ffffff",
  "Vancouver Whitecaps": "#ffffff",
}

const UFL_COLORS = {
  "BHAM": "#a32035",
  "Birmingham Stallions": "#a32035",
  "CLB": "#0c2340",
  "Columbus Aviators": "#0c2340",
  "DAL": "#69b3e7",
  "DC": "#c8102e",
  "DC DEFENDERS": "#c8102e",
  "Dallas Renegades": "#69b3e7",
  "HOU": "#000000",
  "Houston Gamblers": "#000000",
  "LOU": "#06190a",
  "Louisville Kings": "#06190a",
  "ORL": "#fe5000",
  "Orlando Storm": "#fe5000",
  "STL": "#002677",
  "St. Louis Battlehawks": "#002677",
}

const NCAAF_COLORS = {
  "AAMU": "#790000",
  "ABSU": "#000000",
  "ACU": "#592d82",
  "ADR": "#000000",
  "ADSU": "#000000",
  "AF": "#003594",
  "AFST": "#000000",
  "AGSU": "#000000",
  "AIC": "#000000",
  "AKR": "#041e42",
  "ALA": "#9e1b32",
  "ALBI": "#000000",
  "ALBR": "#c82e48",
  "ALCN": "#4b0058",
  "ALFR": "#000000",
  "ALLG": "#000000",
  "ALMA": "#000000",
  "ALST": "#e9a900",
  "AMH": "#3f1f69",
  "ANIN": "#000000",
  "APP": "#000000",
  "APPRE": "#000000",
  "APSU": "#8e0b0b",
  "APU": "#000000",
  "ARIZ": "#cc0033",
  "ARK": "#a32136",
  "ARMY": "#000000",
  "ARST": "#cc092f",
  "ARTE": "#000000",
  "ASH": "#000000",
  "ASP": "#000000",
  "ASU": "#ffc627",
  "AUB": "#002b5c",
  "AUGC": "#000000",
  "AUGS": "#74233d",
  "AUR": "#00549f",
  "AUS": "#000000",
  "AUSD": "#000000",
  "AVE M": "#000000",
  "AVER": "#012853",
  "AVILA": "#000000",
  "Abilene Christian Wildcats": "#592d82",
  "Adams State Grizzlies": "#000000",
  "Adrian Bulldogs": "#000000",
  "Air Force Falcons": "#003594",
  "Akron Zips": "#041e42",
  "Alabama A&M Bulldogs": "#790000",
  "Alabama Crimson Tide": "#9e1b32",
  "Alabama State Hornets": "#e9a900",
  "Albany State Golden Rams": "#000000",
  "Albion Britons": "#000000",
  "Albright Lions": "#c82e48",
  "Alcorn State Braves": "#4b0058",
  "Alfred Saxons": "#000000",
  "Alfred State Pioneers": "#000000",
  "Allegheny Gators": "#000000",
  "Alma Scots": "#000000",
  "American International Yellow Jackets": "#000000",
  "Amherst Mammoths": "#3f1f69",
  "Anderson (IN) Ravens": "#000000",
  "Angelo State Rams": "#000000",
  "App State Mountaineers": "#000000",
  "Apprentice School Builders": "#000000",
  "Arizona State Sun Devils": "#ffc627",
  "Arizona Wildcats": "#cc0033",
  "Arkansas Monticello Boll Weevils": "#000000",
  "Arkansas Razorbacks": "#a32136",
  "Arkansas State Red Wolves": "#cc092f",
  "Arkansas Tech Wonder Boys": "#000000",
  "Arkansas-Pine Bluff Golden Lions": "#e0aa0f",
  "Army Black Knights": "#000000",
  "Ashland Eagles": "#000000",
  "Assumption Greyhounds": "#000000",
  "Auburn Tigers": "#002b5c",
  "Augsburg Auggies": "#74233d",
  "Augustana (IL) Vikings": "#000000",
  "Augustana (SD) Vikings": "#000000",
  "Aurora Spartans": "#00549f",
  "Austin 'Roos": "#000000",
  "Austin Peay Governors": "#8e0b0b",
  "Ave Maria University Gyrenes": "#000000",
  "Averett Cougars": "#012853",
  "Avila University Eagles": "#000000",
  "Azusa Pacific Cougars": "#000000",
  "BAK": "#000000",
  "BALL": "#ba0c2f",
  "BART": "#000000",
  "BATE": "#a51e36",
  "BAY": "#154734",
  "BBM": "#000000",
  "BBU": "#000000",
  "BC": "#8c2232",
  "BCU": "#7b1831",
  "BCWV": "#000000",
  "BELH": "#215732",
  "BELO": "#000000",
  "BENT": "#000000",
  "BERR": "#00205b",
  "BETHA": "#000000",
  "BETHTN": "#000000",
  "BGSU": "#fd5000",
  "BHSU": "#000000",
  "BLF": "#46166a",
  "BNIL": "#000000",
  "BOIS": "#0033a0",
  "BOW": "#ffffff",
  "BOWE": "#000000",
  "BRE": "#000000",
  "BRI": "#990022",
  "BRIS": "#bf2f38",
  "BRO": "#000000",
  "BRWN": "#411e09",
  "BRY": "#000000",
  "BST": "#000000",
  "BSU": "#000000",
  "BTLR": "#0d1361",
  "BUCK": "#000060",
  "BUF": "#005bbb",
  "BUMN": "#002d62",
  "BVU": "#feba12",
  "BW": "#000000",
  "BYU": "#0047ba",
  "BYU Cougars": "#0047ba",
  "Baker University Baker": "#000000",
  "Baldwin Wallace Yellow Jackets": "#000000",
  "Ball State Cardinals": "#ba0c2f",
  "Barton Bulldogs": "#000000",
  "Bates Bobcats": "#a51e36",
  "Baylor Bears": "#154734",
  "Belhaven Blazers": "#215732",
  "Beloit Buccaneers": "#000000",
  "Bemidji State Beavers": "#000000",
  "Benedictine (IL) Eagles": "#000000",
  "Bentley Falcons": "#000000",
  "Berry Vikings": "#00205b",
  "Bethany (Ks)": "#000000",
  "Bethany (WV) Bison": "#000000",
  "Bethel (MN) Royals": "#002d62",
  "Bethel University Tennessee Wildcats": "#000000",
  "Bethune-Cookman Wildcats": "#7b1831",
  "Black Hills State Yellow Jackets": "#000000",
  "Bloomsburg Huskies": "#000000",
  "Bluffton Beavers": "#46166a",
  "Boise State Broncos": "#0033a0",
  "Boston College Eagles": "#8c2232",
  "Bowdoin Polar Bears": "#ffffff",
  "Bowie State Bulldogs": "#000000",
  "Bowling Green Falcons": "#fd5000",
  "Brevard Tornados": "#000000",
  "Bridgewater Eagles": "#990022",
  "Bridgewater State Bears": "#bf2f38",
  "British Columbia British Col": "#000000",
  "Brockport Golden Eagles": "#000000",
  "Brown Bears": "#411e09",
  "Bryant Bulldogs": "#000000",
  "Bucknell Bison": "#000060",
  "Buena Vista Beavers": "#feba12",
  "Buffalo Bulls": "#005bbb",
  "Buffalo State Bengals": "#000000",
  "Butler Bulldogs": "#0d1361",
  "CAL": "#041e42",
  "CALU": "#000000",
  "CAM": "#000000",
  "CAPA": "#000000",
  "CAPU": "#000000",
  "CAR": "#173a79",
  "CARK": "#a7a9ac",
  "CAT": "#0c233f",
  "CATH": "#000000",
  "CC": "#65448b",
  "CCMN": "#701d45",
  "CCO": "#000000",
  "CCSU": "#1b49a2",
  "CCU": "#006f71",
  "CCW": "#000000",
  "CDF": "#000000",
  "CGMU": "#000000",
  "CHAD": "#000000",
  "CHAP": "#ab1d38",
  "CHI": "#000000",
  "CHSO": "#2e3192",
  "CIN": "#000000",
  "CIT": "#7badd3",
  "CKGA": "#000000",
  "CLBY": "#012778",
  "CLEM": "#f56600",
  "CLRN": "#000000",
  "CLT": "#005035",
  "CLU": "#3b2361",
  "CMBS": "#000000",
  "CMIN": "#000000",
  "CMS": "#981a31",
  "CMU": "#4c0027",
  "CN": "#f2682a",
  "CNIA": "#000000",
  "CNSU": "#000000",
  "CNTC": "#ea0029",
  "CNU": "#000000",
  "COE": "#881922",
  "COLG": "#821019",
  "COLO": "#cfb87c",
  "COLU": "#7ba4db",
  "COMU": "#000000",
  "CONC": "#000000",
  "CONCMI": "#000000",
  "CONN": "#0c2340",
  "COR": "#b31b1b",
  "CP": "#1e4d2b",
  "CRU": "#000000",
  "CRWN": "#5c2f92",
  "CSP": "#000000",
  "CSS": "#000000",
  "CSU": "#004c23",
  "CSU Pueblo ThunderWolves": "#000000",
  "CSUP": "#000000",
  "CTLA": "#000000",
  "CUC": "#572a31",
  "CUW": "#245699",
  "CWAN": "#000000",
  "CWAU": "#000000",
  "CWRU": "#000000",
  "Cal Lutheran Kingsmen": "#3b2361",
  "Cal Poly Mustangs": "#1e4d2b",
  "California (PA) Vulcans": "#000000",
  "California Golden Bears": "#041e42",
  "Calvin Knights": "#000000",
  "Campbell Fighting Camels": "#000000",
  "Capital Comets": "#000000",
  "Carleton Knights": "#173a79",
  "Carnegie Mellon Tartans": "#000000",
  "Carroll (WI) Pioneers": "#000000",
  "Carson Newman Eagles": "#f2682a",
  "Carthage Firebirds": "#000000",
  "Case Western Reserve Spartans": "#000000",
  "Catawba Indians": "#0c233f",
  "Catholic Cardinals": "#000000",
  "Centenary (LA) Gentlemen": "#000000",
  "Central Arkansas Bears": "#a7a9ac",
  "Central College Dutch": "#ea0029",
  "Central Connecticut Blue Devils": "#1b49a2",
  "Central Methodist Eagles": "#000000",
  "Central Michigan Chippewas": "#4c0027",
  "Central Missouri Mules": "#000000",
  "Central Oklahoma Bronchos": "#000000",
  "Central State Marauders": "#000000",
  "Central Washington Wildcats": "#000000",
  "Centre Colonels": "#000000",
  "Chadron State Eagles": "#000000",
  "Chapman Panthers": "#ab1d38",
  "Charleston (WV) Golden Eagles": "#000000",
  "Charleston Southern Buccaneers": "#2e3192",
  "Charlotte 49ers": "#005035",
  "Chattanooga Mocs": "#00386b",
  "Chicago Maroons": "#000000",
  "Chowan Hawks": "#000000",
  "Christopher Newport Captains": "#000000",
  "Cincinnati Bearcats": "#000000",
  "Claremont Mudd Scripps Stags": "#981a31",
  "Clarion Golden Eagles": "#000000",
  "Clark Atlanta Panthers": "#000000",
  "Clemson Tigers": "#f56600",
  "Coast Guard Bears": "#000000",
  "Coastal Carolina Chanticleers": "#006f71",
  "Coe Kohawks": "#881922",
  "Colby White Mules": "#012778",
  "Colgate Raiders": "#821019",
  "Colorado Buffaloes": "#cfb87c",
  "Colorado Mesa Mavericks": "#000000",
  "Colorado School of Mines Orediggers": "#000000",
  "Colorado State Rams": "#004c23",
  "Columbia Lions": "#7ba4db",
  "Concord Mountain Lions": "#000000",
  "Concordia (MN) Cobbers": "#701d45",
  "Concordia (WI) Falcons": "#245699",
  "Concordia Chicago Cougars": "#572a31",
  "Concordia St. Paul Golden Bears": "#000000",
  "Concordia-Michigan Cardinals": "#000000",
  "Cornell (IA) Rams": "#000000",
  "Cornell Big Red": "#b31b1b",
  "Crown Polars": "#5c2f92",
  "Cumberlands Indians": "#000000",
  "Curry Colonels": "#65448b",
  "DAKOT": "#000000",
  "DART": "#005730",
  "DAV": "#000000",
  "DAY": "#004b8d",
  "DBQ": "#000000",
  "DEF": "#4e2d8a",
  "DEL": "#00539f",
  "DIC": "#000000",
  "DKSN": "#ed192d",
  "DLST": "#00753e",
  "DPU": "#000000",
  "DRKE": "#005596",
  "DSN": "#000000",
  "DSU": "#009cdb",
  "DUKE": "#00539b",
  "DUQ": "#002d62",
  "DVU": "#004c23",
  "Dakota State University Trojans": "#000000",
  "Dartmouth Big Green": "#005730",
  "Davidson Wildcats": "#000000",
  "Dayton Flyers": "#004b8d",
  "DePauw Tigers": "#000000",
  "Defiance College Yellow Jackets": "#4e2d8a",
  "Delaware Blue Hens": "#00539f",
  "Delaware State Hornets": "#009cdb",
  "Delaware Valley Aggies": "#004c23",
  "Delta State Statesmen": "#00753e",
  "Denison Big Red": "#000000",
  "Dickinson Red Devils": "#ed192d",
  "Dickinson State University Blue Hawks": "#000000",
  "Drake Bulldogs": "#005596",
  "Dubuque Spartans": "#000000",
  "Duke Blue Devils": "#00539b",
  "Duquesne Dukes": "#002d62",
  "ECNU": "#000000",
  "ECSU": "#000000",
  "ECU": "#582c83",
  "EDBR": "#000000",
  "EHC": "#1e376d",
  "EIU": "#000000",
  "EKU": "#660819",
  "ELMH": "#000000",
  "ELON": "#020303",
  "EMSU": "#000000",
  "EMU": "#006938",
  "ENDC": "#000000",
  "ENMU": "#000000",
  "ERKA": "#960a2c",
  "ERSK": "#000000",
  "ESU": "#000000",
  "ETAM": "#000000",
  "ETBU": "#002b44",
  "ETSU": "#002d61",
  "EWU": "#a10022",
  "East Carolina Pirates": "#582c83",
  "East Central Tigers": "#000000",
  "East Stroudsburg Warriors": "#000000",
  "East Tennessee State Buccaneers": "#002d61",
  "East Texas A&M Lions": "#000000",
  "East Texas Baptist Tigers": "#002b44",
  "Eastern Illinois Panthers": "#000000",
  "Eastern Kentucky Colonels": "#660819",
  "Eastern Michigan Eagles": "#006938",
  "Eastern New Mexico Greyhounds": "#000000",
  "Eastern Washington Eagles": "#a10022",
  "Edinboro Fighting Scots": "#000000",
  "Elizabeth City State Vikings": "#000000",
  "Elmhurst Bluejays": "#000000",
  "Elon Phoenix": "#020303",
  "Emory & Henry Wasps": "#1e376d",
  "Emporia State Hornets": "#000000",
  "Endicott Gulls": "#000000",
  "Erskine Flying Fleet": "#000000",
  "Eureka Red Devils": "#960a2c",
  "FAMU": "#f89728",
  "FAU": "#003366",
  "FAULKNER": "#000000",
  "FAYU": "#000000",
  "FBSU": "#024d36",
  "FC": "#000000",
  "FDU Florham Devils": "#003f87",
  "FDUF": "#003f87",
  "FHSU": "#000000",
  "FIU": "#091f3f",
  "FLA": "#0021a5",
  "FLWC": "#000000",
  "FMC": "#25377d",
  "FMSU": "#000000",
  "FOR": "#830032",
  "FRES": "#b1102b",
  "FRKL": "#1b295b",
  "FRST": "#000000",
  "FRSU": "#000000",
  "FSTU": "#000000",
  "FSU": "#782f40",
  "FUR": "#582c83",
  "FVSU": "#f9bd0a",
  "Fairmont State Falcons": "#000000",
  "Faulkner University Eagles": "#000000",
  "Fayetteville State Broncos": "#000000",
  "Ferris State Bulldogs": "#000000",
  "Ferrum Panthers": "#000000",
  "Findlay Oilers": "#000000",
  "Fitchburg State Falcons": "#024d36",
  "Florida A&M Rattlers": "#f89728",
  "Florida Atlantic Owls": "#003366",
  "Florida Gators": "#0021a5",
  "Florida International Panthers": "#091f3f",
  "Florida State Seminoles": "#782f40",
  "Fordham Rams": "#830032",
  "Fort Hays Tigers": "#000000",
  "Fort Lewis Skyhawks": "#000000",
  "Fort Valley State Wildcats": "#f9bd0a",
  "Framingham State Rams": "#000000",
  "Franklin & Marshall Diplomats": "#25377d",
  "Franklin Grizzlies": "#1b295b",
  "Fresno State Bulldogs": "#b1102b",
  "Frostburg State Bobcats": "#000000",
  "Furman Paladins": "#582c83",
  "GAC": "#000000",
  "GANN": "#000000",
  "GASO": "#041e42",
  "GAST": "#0039a6",
  "GEN": "#000000",
  "GFU": "#002d62",
  "GLDT": "#000000",
  "GLFD": "#910028",
  "GMU": "#016600",
  "GRAM": "#ee8601",
  "GRC": "#000000",
  "GRNB": "#000000",
  "GRNL": "#000000",
  "GRNV": "#f36917",
  "GRO": "#000000",
  "GT": "#b3a369",
  "GTWN": "#110e42",
  "GTYB": "#000000",
  "GVLS": "#000000",
  "GVSU": "#000000",
  "GWEB": "#c12535",
  "Gallaudet Bison": "#000000",
  "Gannon Golden Knights": "#000000",
  "Gardner-Webb Runnin' Bulldogs": "#c12535",
  "Geneva Golden Tornadoes": "#000000",
  "George Fox Bruins": "#002d62",
  "George Mason University Patriots": "#016600",
  "Georgetown Hoyas": "#110e42",
  "Georgia Bulldogs": "#ba0c2f",
  "Georgia Southern Eagles": "#041e42",
  "Georgia State Panthers": "#0039a6",
  "Georgia Tech Yellow Jackets": "#b3a369",
  "Gettysburg Bullets": "#000000",
  "Glenville State Pioneers": "#000000",
  "Graceland University Graceland": "#000000",
  "Grambling Tigers": "#ee8601",
  "Grand Valley State Lakers": "#000000",
  "Greensboro Pride": "#000000",
  "Greenville Panthers": "#f36917",
  "Grinnell Pioneers": "#000000",
  "Grove City Wolverines": "#000000",
  "Guilford Quakers": "#910028",
  "Gustavus Adolphus Golden Gusties": "#000000",
  "HAM": "#062f87",
  "HAMP": "#0067ac",
  "HARD": "#000000",
  "HARV": "#990000",
  "HASKELL": "#000000",
  "HAW": "#005737",
  "HBRT": "#000000",
  "HC": "#582c83",
  "HCU": "#00539c",
  "HDBG": "#000000",
  "HIRM": "#000000",
  "HLDL": "#000000",
  "HMLN": "#98012e",
  "HNTC": "#000000",
  "HNVR": "#0b486d",
  "HOPE": "#000000",
  "HOU": "#c8102e",
  "HOW": "#003a63",
  "HRTW": "#000000",
  "HSC": "#900028",
  "HSTU": "#000000",
  "HSU": "#5b2d83",
  "HUSS": "#004b44",
  "HWPU": "#02215b",
  "Hamilton Continentals": "#062f87",
  "Hamline Pipers": "#98012e",
  "Hampden Sydney Tigers": "#900028",
  "Hampton Pirates": "#0067ac",
  "Hanover Panthers": "#0b486d",
  "Hardin Simmons Cowboys": "#5b2d83",
  "Harding Bisons": "#000000",
  "Hartwick Hawks": "#000000",
  "Harvard Crimson": "#990000",
  "Haskell Indian Nations Univ Jayhawks": "#000000",
  "Hawai'i Rainbow Warriors": "#005737",
  "Heidelberg Student Princes": "#000000",
  "Henderson State Reddies": "#000000",
  "Hillsdale Chargers": "#000000",
  "Hiram Terriers": "#000000",
  "Hobart Statesmen": "#000000",
  "Holy Cross Crusaders": "#582c83",
  "Hope Flying Dutchmen": "#000000",
  "Houston Christian Huskies": "#00539c",
  "Houston Cougars": "#c8102e",
  "Howard Bison": "#003a63",
  "Howard Payne Yellow Jackets": "#02215b",
  "Huntingdon Hawks": "#000000",
  "Husson Eagles": "#004b44",
  "IDHO": "#000000",
  "IDST": "#ef8c00",
  "ILL": "#ff5f05",
  "ILLC": "#000000",
  "ILST": "#ce1126",
  "ILWU": "#000000",
  "INDY": "#000000",
  "INST": "#00669a",
  "IOWA": "#231f20",
  "ISU": "#ae192d",
  "ITH": "#000000",
  "IU": "#970310",
  "IU Pennsylvania Crimson Hawks": "#000000",
  "IUP": "#000000",
  "Idaho State Bengals": "#ef8c00",
  "Idaho Vandals": "#000000",
  "Illinois College Blueboys": "#000000",
  "Illinois Fighting Illini": "#ff5f05",
  "Illinois State Redbirds": "#ce1126",
  "Illinois Wesleyan Titans": "#000000",
  "Incarnate Word Cardinals": "#000000",
  "Indiana Hoosiers": "#970310",
  "Indiana State Sycamores": "#00669a",
  "Indianapolis Greyhounds": "#000000",
  "Iowa Hawkeyes": "#231f20",
  "Iowa State Cyclones": "#ae192d",
  "Ithaca Bombers": "#000000",
  "JCSU": "#000000",
  "JCU": "#000000",
  "JHU": "#000000",
  "JKST": "#123297",
  "JMU": "#450084",
  "JUN": "#031832",
  "JXST": "#cc0000",
  "Jackson State Tigers": "#123297",
  "Jacksonville State Gamecocks": "#cc0000",
  "James Madison Dukes": "#450084",
  "Jamestown Jimmies": "#000000",
  "John Carroll Blue Streaks": "#000000",
  "Johns Hopkins Blue Jays": "#000000",
  "Johnson C. Smith Golden Bulls": "#000000",
  "Juniata Eagles": "#031832",
  "KALC": "#000000",
  "KANSA": "#000000",
  "KEAN": "#092f56",
  "KENN": "#fdbb30",
  "KENT": "#002664",
  "KNGS": "#c41230",
  "KNOX": "#000000",
  "KNY": "#000000",
  "KSU": "#330a57",
  "KU": "#0051ba",
  "KUTZ": "#000000",
  "KWC": "#000000",
  "KYCHR": "#000000",
  "KYSU": "#000000",
  "Kalamazoo Hornets": "#000000",
  "Kansas Jayhawks": "#0051ba",
  "Kansas State Wildcats": "#330a57",
  "Kansas Wesleyan Ks Wesleyan": "#000000",
  "Kean Cougars": "#092f56",
  "Kennesaw State Owls": "#fdbb30",
  "Kent State Golden Flashes": "#002664",
  "Kentucky Christian Knights": "#000000",
  "Kentucky State Thorobreds": "#000000",
  "Kentucky Wesleyan Panthers": "#000000",
  "Kentucky Wildcats": "#0033a0",
  "Kenyon Owls": "#000000",
  "King's Monarchs": "#c41230",
  "Knox Prairie Fire": "#000000",
  "Kutztown Golden Bears": "#000000",
  "LAF": "#790000",
  "LAM": "#000000",
  "LANE": "#000000",
  "LAW": "#000000",
  "LC": "#f37737",
  "LCHR": "#000000",
  "LEH": "#6c2b2a",
  "LENR": "#000000",
  "LFC": "#000000",
  "LGC": "#000000",
  "LHU": "#000000",
  "LIB": "#0a254e",
  "LIN": "#000000",
  "LINF": "#46256a",
  "LIV": "#000000",
  "LKER": "#000000",
  "LNMO": "#000000",
  "LNPA": "#000000",
  "LOR": "#452d7d",
  "LOU": "#c9001f",
  "LSU": "#461d76",
  "LSU Tigers": "#461d76",
  "LT": "#003087",
  "LUTH": "#015a9c",
  "LVC": "#003767",
  "LYCO": "#15283f",
  "LYON": "#000000",
  "La Verne Leopards": "#004812",
  "LaGrange Panthers": "#000000",
  "Lafayette Leopards": "#790000",
  "Lake Erie Storm": "#000000",
  "Lake Forest Foresters": "#000000",
  "Lamar Cardinals": "#000000",
  "Lane College Dragons": "#000000",
  "Lawrence Vikings": "#000000",
  "Lebanon Valley Flying Dutchmen": "#003767",
  "Lehigh Mountain Hawks": "#6c2b2a",
  "Lenoir Rhyne Bears": "#000000",
  "Lewis & Clark River Otters": "#f37737",
  "Liberty Flames": "#0a254e",
  "Lincoln (MO) Blue Tigers": "#000000",
  "Lincoln (PA) Lions": "#000000",
  "Lindenwood Lions": "#000000",
  "Linfield Wildcats": "#46256a",
  "Livingstone Blue Bears": "#000000",
  "Lock Haven Bald Eagles": "#000000",
  "Loras Duhawks": "#452d7d",
  "Louisiana Christian Wildcats": "#000000",
  "Louisiana Ragin' Cajuns": "#ce181e",
  "Louisiana Tech Bulldogs": "#003087",
  "Louisville Cardinals": "#c9001f",
  "Luther Norse": "#015a9c",
  "Lycoming Warriors": "#15283f",
  "Lyon Scots": "#000000",
  "M-OH": "#c41230",
  "MAC": "#000000",
  "MANITOBA": "#000000",
  "MARY": "#000000",
  "MASS": "#881c1c",
  "MB": "#000000",
  "MCD": "#00674d",
  "MCK": "#000000",
  "MCM": "#98002e",
  "MCN": "#00529c",
  "MCST": "#c20f2f",
  "MCTN": "#000000",
  "MD": "#ce1126",
  "MDAR": "#000000",
  "ME": "#127dbe",
  "MEM": "#004991",
  "MER": "#ff7f29",
  "MERC": "#000000",
  "MHB": "#492f92",
  "MHU": "#004b8d",
  "MIA": "#f47423",
  "MICH": "#00274c",
  "MIDB": "#365a8a",
  "MIDL": "#000000",
  "MILE": "#000000",
  "MILK": "#000000",
  "MILL": "#000000",
  "MINN": "#5e0a2f",
  "MINS": "#000000",
  "MISE": "#000000",
  "MISS": "#13294b",
  "MIT": "#000000",
  "MIT Engineers": "#000000",
  "MITE": "#000000",
  "MIZ": "#f1b82d",
  "MLC": "#000000",
  "MLSP": "#000000",
  "MMA": "#000000",
  "MMT": "#212c62",
  "MNCH": "#ddac14",
  "MNFD": "#000000",
  "MNGS": "#000000",
  "MNIL": "#000000",
  "MNMO": "#8d191b",
  "MNST": "#000000",
  "MONM": "#051844",
  "MONT": "#751d4a",
  "MOR": "#1f3361",
  "MORE": "#094fa3",
  "MORG": "#014786",
  "MOST": "#5e0009",
  "MOWE": "#000000",
  "MRHO": "#000000",
  "MRMK": "#000000",
  "MRSH": "#00b140",
  "MRST": "#e53730",
  "MRTT": "#000000",
  "MS&T": "#000000",
  "MSJ": "#002d5d",
  "MSK": "#000000",
  "MSST": "#5d1725",
  "MSSU": "#000000",
  "MSU": "#173f35",
  "MSUM": "#000000",
  "MTST": "#00205c",
  "MTSU": "#036eb7",
  "MTU": "#000000",
  "MU": "#000000",
  "MUHL": "#000000",
  "MUIN": "#000000",
  "MUR": "#002148",
  "MVSU": "#005328",
  "MWMO": "#000000",
  "MWSU": "#000000",
  "MYSU": "#000000",
  "Macalester Scots": "#000000",
  "Maine Black Bears": "#127dbe",
  "Maine Maritime Mariners": "#000000",
  "Manchester Spartans": "#ddac14",
  "Mansfield Mountaineers": "#000000",
  "Marian (IN) MARIAN": "#000000",
  "Marietta Pioneers": "#000000",
  "Marist Red Foxes": "#e53730",
  "Mars Hill Lions": "#004b8d",
  "Marshall Thundering Herd": "#00b140",
  "Martin Luther Knights": "#000000",
  "Mary Hardin Baylor Crusaders": "#492f92",
  "Maryland Terrapins": "#ce1126",
  "Maryville (TN) Scots": "#000000",
  "Mass Maritime Buccaneers": "#212c62",
  "Massachusetts Minutemen": "#881c1c",
  "UMass Minutemen": "#881c1c",
  "UMass": "#881c1c",
  "Mayville State Comets": "#000000",
  "McDaniel Green Terror": "#00674d",
  "McKendree Bearcats": "#000000",
  "McMurry War Hawks": "#98002e",
  "McNeese Cowboys": "#00529c",
  "Memphis Tigers": "#004991",
  "Mercer Bears": "#ff7f29",
  "Merchant Marine Mariners": "#000000",
  "Mercyhurst Lakers": "#000000",
  "Merrimack Warriors": "#000000",
  "Methodist Monarchs": "#000000",
  "Miami (OH) RedHawks": "#c41230",
  "Miami Hurricanes": "#f47423",
  "Michigan State Spartans": "#173f35",
  "Michigan Tech Huskies": "#000000",
  "Michigan Wolverines": "#00274c",
  "Middle Tennessee Blue Raiders": "#036eb7",
  "Middlebury Panthers": "#365a8a",
  "Midland MIDLAND LUTHERAN": "#000000",
  "Midwestern State Mustangs": "#000000",
  "Miles Golden Bears": "#000000",
  "Millersville Marauders": "#000000",
  "Millikin Big Blue": "#000000",
  "Millsaps Majors": "#000000",
  "Minnesota Duluth Bulldogs": "#000000",
  "Minnesota Golden Gophers": "#5e0a2f",
  "Minnesota Morris Cougars": "#8d191b",
  "Minnesota St Moorhead Dragons": "#000000",
  "Minnesota State Mavericks": "#000000",
  "Minot State Beavers": "#000000",
  "Misericordia Cougars": "#000000",
  "Mississippi State Bulldogs": "#5d1725",
  "Mississippi Valley State Delta Devils": "#005328",
  "Missouri S&T Miners": "#000000",
  "Missouri Southern State Lions": "#000000",
  "Missouri State Bears": "#5e0009",
  "Missouri Tigers": "#f1b82d",
  "Missouri Western Griffons": "#000000",
  "Monmouth (IL) Fighting Scots": "#000000",
  "Monmouth Hawks": "#051844",
  "Montana Grizzlies": "#751d4a",
  "Montana State Bobcats": "#00205c",
  "Montana Western Bulldogs": "#000000",
  "Montclair State Red Hawks": "#c20f2f",
  "Monterrey Tech Borregos": "#000000",
  "Moravian Greyhounds": "#1f3361",
  "Morehead State Eagles": "#094fa3",
  "Morehouse Maroon Tigers": "#000000",
  "Morgan State Bears": "#014786",
  "Morningside Chiefs": "#000000",
  "Mount St Joseph Lions": "#002d5d",
  "Mount Union Purple Raiders": "#000000",
  "Muhlenberg Mules": "#000000",
  "Murray State Racers": "#002148",
  "Muskingum Fighting Muskies": "#000000",
  "NAU": "#003976",
  "NAVY": "#00225b",
  "NBRY": "#d02030",
  "NC State Wolfpack": "#cc0000",
  "NCAT": "#0505aa",
  "NCC": "#000000",
  "NCCU": "#880023",
  "NCSU": "#cc0000",
  "NCW": "#000000",
  "ND": "#062340",
  "NDSU": "#01402a",
  "NEB": "#e31937",
  "NEBK": "#000000",
  "NEL": "#000000",
  "NESU": "#000000",
  "NEV": "#041e42",
  "NGU": "#d91e39",
  "NHVN": "#041e42",
  "NICC": "#007b5f",
  "NICH": "#c41230",
  "NIU": "#c8102e",
  "NMHU": "#000000",
  "NMI": "#000000",
  "NMSU": "#7e141b",
  "NORF": "#0c8968",
  "NPU": "#000000",
  "NSU": "#000000",
  "NU": "#492f92",
  "NWCH": "#000000",
  "NWD": "#000000",
  "NWOK": "#000000",
  "NWST": "#492f91",
  "NYCL": "#000000",
  "NYMS": "#000000",
  "NYMT": "#000000",
  "Navy Midshipmen": "#00225b",
  "Nebraska Cornhuskers": "#e31937",
  "Nebraska Kearney Lopers": "#000000",
  "Nelson (TX) Lions": "#000000",
  "Nevada Wolf Pack": "#041e42",
  "New Hampshire Wildcats": "#004990",
  "New Haven Chargers": "#041e42",
  "New Mexico Highlands Cowboys": "#000000",
  "New Mexico Lobos": "#ba0c2f",
  "New Mexico State Aggies": "#7e141b",
  "Newberry Wolves": "#d02030",
  "Nicholls Colonels": "#c41230",
  "Nichols Bison": "#007b5f",
  "Norfolk State Spartans": "#0c8968",
  "North Alabama Lions": "#000000",
  "North Carolina A&T Aggies": "#0505aa",
  "North Carolina Central Eagles": "#880023",
  "North Carolina Tar Heels": "#7bafd4",
  "North Carolina Wesleyan Battling Bishops": "#000000",
  "North Central College Cardinals": "#000000",
  "North Dakota Fighting Hawks": "#00a26b",
  "North Dakota State Bison": "#01402a",
  "North Greenville Trailblazers": "#d91e39",
  "North Park Vikings": "#000000",
  "North Texas Mean Green": "#068f33",
  "Northeastern State RiverHawks": "#000000",
  "Northern Arizona Lumberjacks": "#003976",
  "Northern Colorado Bears": "#13558d",
  "Northern Illinois Huskies": "#c8102e",
  "Northern Iowa Panthers": "#473282",
  "Northern Michigan Wildcats": "#000000",
  "Northern State Wolves": "#000000",
  "Northwest Missouri State Bearcats": "#000000",
  "Northwestern (MN) Eagles": "#000000",
  "Northwestern (OK) Rangers": "#000000",
  "Northwestern State Demons": "#492f91",
  "Northwestern Wildcats": "#492f92",
  "Northwood Timberwolves": "#000000",
  "Norwich Cadets": "#000000",
  "Notre Dame Fighting Irish": "#062340",
  "OBE": "#000000",
  "OBU": "#000000",
  "ODU": "#003768",
  "OHIO": "#154734",
  "OHNU": "#000000",
  "OKST": "#fe5c00",
  "OLAF": "#000000",
  "OPSU": "#000000",
  "ORE": "#00934b",
  "ORST": "#dc4405",
  "OSU": "#000000",
  "OTTB": "#000000",
  "OU": "#990000",
  "OWU": "#000000",
  "Oberlin Yeomen": "#000000",
  "Ohio Bobcats": "#154734",
  "Ohio Northern Polar Bears": "#000000",
  "Ohio State Buckeyes": "#ba0c2f",
  "Ohio State Newark Titans": "#000000",
  "Ohio Wesleyan Battling Bishops": "#000000",
  "Oklahoma Panhandle OK PANHANDLE ST": "#000000",
  "Oklahoma Sooners": "#990000",
  "Oklahoma State Cowboys": "#fe5c00",
  "Old Dominion Monarchs": "#003768",
  "Ole Miss Rebels": "#13294b",
  "Olivet Comets": "#000000",
  "Oregon Ducks": "#00934b",
  "Oregon State Beavers": "#dc4405",
  "Otterbein Cardinals": "#000000",
  "Ouachita Baptist Tigers": "#000000",
  "PACE": "#000000",
  "PCLT": "#ffc423",
  "PCOR": "#b4183a",
  "PENN": "#082a74",
  "PITT": "#003594",
  "PLYM": "#054e39",
  "POPI": "#00549a",
  "PRES": "#194896",
  "PRIN": "#000000",
  "PRST": "#00311e",
  "PSU": "#061440",
  "PTSU": "#000000",
  "PUG": "#680001",
  "PUR": "#ceb888",
  "PV": "#582c83",
  "Pace Setters": "#000000",
  "Pacific (OR) Boxers": "#b4183a",
  "Pacific Lutheran Lutes": "#ffc423",
  "Penn State Nittany Lions": "#061440",
  "Pennsylvania Quakers": "#082a74",
  "Pittsburg State Gorillas": "#000000",
  "Pittsburgh Panthers": "#003594",
  "Plymouth State Panthers": "#054e39",
  "Pomona Pitzer Sagehens": "#00549a",
  "Portland State Vikings": "#00311e",
  "Prairie View A&M Panthers": "#582c83",
  "Presbyterian Blue Hose": "#194896",
  "Princeton Tigers": "#000000",
  "Puget Sound Loggers": "#680001",
  "Purdue Boilermakers": "#ceb888",
  "QUI": "#000000",
  "Quincy Hawks": "#000000",
  "REDL": "#751708",
  "RFU": "#5a3f99",
  "RHDS": "#000000",
  "RHIT": "#800000",
  "RICE": "#00205b",
  "RICH": "#9e0712",
  "RIP": "#000000",
  "RMC": "#fcdf12",
  "RMU": "#00214d",
  "ROW": "#571b04",
  "RPI": "#000000",
  "RSVT": "#000000",
  "RUTG": "#ce0e2d",
  "Randolph Macon Yellow Jackets": "#fcdf12",
  "Redlands Bulldogs": "#751708",
  "Rensselaer Engineers": "#000000",
  "Rhode Island Rams": "#091f3f",
  "Rhodes Lynx": "#000000",
  "Rice Owls": "#00205b",
  "Richmond Spiders": "#9e0712",
  "Ripon Red Hawks": "#000000",
  "Robert Morris Colonials": "#00214d",
  "Rochester (NY) Yellow Jackets": "#000000",
  "Rockford Regents": "#5a3f99",
  "Roosevelt Lakers": "#000000",
  "Rose Hulman Fightin' Engineers": "#800000",
  "Rowan Profs": "#571b04",
  "Rutgers Scarlet Knights": "#ce0e2d",
  "SAC": "#00573c",
  "SAL": "#8b0e04",
  "SALV": "#000000",
  "SAM": "#005485",
  "SANS": "#000000",
  "SAR": "#000000",
  "SAV": "#280298",
  "SC": "#73000a",
  "SCIA": "#b20838",
  "SCST": "#7d1315",
  "SCTS": "#000000",
  "SDAK": "#cd1241",
  "SDMT": "#000000",
  "SDST": "#0033a0",
  "SDSU": "#a6192e",
  "SE Louisiana Lions": "#215732",
  "SEHI": "#000000",
  "SELA": "#215732",
  "SEMO": "#c8102e",
  "SEOK": "#000000",
  "SEU": "#007dc3",
  "SEWA": "#000000",
  "SFA": "#393996",
  "SFIL": "#000000",
  "SFIN": "#000000",
  "SFPA": "#a20012",
  "SFU": "#000000",
  "SHAW": "#000000",
  "SHEN": "#000000",
  "SHEP": "#000000",
  "SHIP": "#000000",
  "SHOU": "#000000",
  "SHSU": "#f56423",
  "SHTU": "#000000",
  "SHU": "#a40012",
  "SIU": "#85283d",
  "SJSU": "#0038a8",
  "SMU": "#a80000",
  "SMU Mustangs": "#a80000",
  "SNU": "#000000",
  "SOSU": "#000000",
  "SOU": "#004b97",
  "SOVA": "#000000",
  "SPR": "#000000",
  "SRST": "#000000",
  "SRU": "#000000",
  "STAM": "#000000",
  "STAN": "#8c1515",
  "STBK": "#990000",
  "STET": "#0a5640",
  "STJF": "#000000",
  "STJM": "#ce153e",
  "STLG": "#000000",
  "STMN": "#000000",
  "STNC": "#000000",
  "STO": "#000000",
  "STVS": "#005747",
  "STX": "#000000",
  "SUNY Cortland Red Dragons": "#000000",
  "SUNY Maritime Privateers": "#000000",
  "SUNY Morrisville Mustangs": "#000000",
  "SUSQ": "#6b1a31",
  "SUU": "#c72026",
  "SVC": "#000000",
  "SVSU": "#000000",
  "SWBU": "#000000",
  "SWKS": "#000000",
  "SWMS": "#000000",
  "SWU": "#000000",
  "SYR": "#000e54",
  "Sacramento State Hornets": "#00573c",
  "Sacred Heart Pioneers": "#a40012",
  "Saginaw Valley State Cardinals": "#000000",
  "Saint Anselm Hawks": "#000000",
  "Saint Francis (IN) Cougars": "#000000",
  "Saint Francis Red Flash": "#a20012",
  "Saint John's (MN) Johnnies": "#ce153e",
  "Saint Vincent Bearcats": "#000000",
  "Saint Xavier Cougars": "#000000",
  "Salisbury Sea Gulls": "#8b0e04",
  "Salve Regina Seahawks": "#000000",
  "Sam Houston Bearkats": "#f56423",
  "Samford Bulldogs": "#005485",
  "San Diego State Aztecs": "#a6192e",
  "San Diego Toreros": "#2f99d4",
  "San José State Spartans": "#0038a8",
  "Savannah State Tigers": "#280298",
  "Seton Hill Griffins": "#000000",
  "Sewanee Tigers": "#000000",
  "Shaw Bears": "#000000",
  "Shenandoah Hornets": "#000000",
  "Shepherd Rams": "#000000",
  "Shippensburg Raiders": "#000000",
  "Shorter Hawks": "#000000",
  "Siena Heights Saints": "#000000",
  "Simpson (IA) Storm": "#b20838",
  "Sioux Falls Cougars": "#000000",
  "Slippery Rock The Rock": "#000000",
  "South Alabama Jaguars": "#00205b",
  "South Carolina Gamecocks": "#73000a",
  "South Carolina State Bulldogs": "#7d1315",
  "South Dakota Coyotes": "#cd1241",
  "South Dakota Mines Hardrockers": "#000000",
  "South Dakota State Jackrabbits": "#0033a0",
  "South Florida Bulls": "#006747",
  "Southeast Missouri State Redhawks": "#c8102e",
  "Southeastern Fires": "#007dc3",
  "Southeastern Oklahoma State Savage Storm": "#000000",
  "Southern Arkansas Muleriders": "#000000",
  "Southern Connecticut State Owls": "#000000",
  "Southern Illinois Salukis": "#85283d",
  "Southern Jaguars": "#004b97",
  "Southern Miss Golden Eagles": "#ffc72c",
  "Southern Nazarene Crimson Storm": "#000000",
  "Southern Utah Thunderbirds": "#c72026",
  "Southern Virginia Knights": "#000000",
  "Southwest Baptist Bearcats": "#000000",
  "Southwest Minnesota State Mustangs": "#000000",
  "Southwestern (KS) Moundbuilders": "#000000",
  "Southwestern Oklahoma State Bulldogs": "#000000",
  "Southwestern U Pirates": "#000000",
  "Springfield Pride": "#000000",
  "St. Ambrose Fighting Bees": "#000000",
  "St. Francis (IL) Fighting Saints": "#000000",
  "St. John Fisher Cardinals": "#000000",
  "St. Lawrence Saints": "#000000",
  "St. Norbert Green Knights": "#000000",
  "St. Olaf Oles": "#000000",
  "St. Scholastica Saints": "#000000",
  "St. Thomas Tommies": "#000000",
  "Stanford Cardinal": "#8c1515",
  "Stephen F. Austin Lumberjacks": "#393996",
  "Sterling STERLING KS": "#000000",
  "Stetson Hatters": "#0a5640",
  "Stevenson Mustangs": "#005747",
  "Stonehill Skyhawks": "#000000",
  "Stony Brook Seawolves": "#990000",
  "Sul Ross State Lobos": "#000000",
  "Susquehanna River Hawks": "#6b1a31",
  "Syracuse Orange": "#000e54",
  "TA&M": "#500000",
  "TAMK": "#000000",
  "TAR": "#000000",
  "TCCT": "#032d58",
  "TCNJ": "#154c7d",
  "TCU": "#4d1979",
  "TCU Horned Frogs": "#4d1979",
  "TEM": "#a41e35",
  "TENN": "#ff8200",
  "TEX": "#af5c37",
  "THI": "#000000",
  "TIFF": "#000000",
  "TLRU": "#000000",
  "TLSA": "#003595",
  "TMOR": "#000000",
  "TNST": "#171796",
  "TNTC": "#5a4099",
  "TOL": "#0b2240",
  "TOW": "#ffc229",
  "TRNE": "#000000",
  "TROY": "#862633",
  "TRST": "#000000",
  "TTU": "#da291c",
  "TUFT": "#3e8ede",
  "TULN": "#006747",
  "TUSC": "#f2682a",
  "TUSK": "#000000",
  "TUTX": "#000000",
  "TXLU": "#fdbe10",
  "TXSO": "#860038",
  "TXST": "#501214",
  "Tarleton State Texans": "#000000",
  "Taylor Trojans": "#000000",
  "Temple Owls": "#a41e35",
  "Tennessee State Tigers": "#171796",
  "Tennessee Tech Golden Eagles": "#5a4099",
  "Tennessee Volunteers": "#ff8200",
  "Texas A&M Aggies": "#500000",
  "Texas A&M-Kingsville Javelinas": "#000000",
  "Texas Longhorns": "#af5c37",
  "Texas Lutheran Bulldogs": "#fdbe10",
  "Texas Southern Tigers": "#860038",
  "Texas State Bobcats": "#501214",
  "Texas Tech Red Raiders": "#da291c",
  "The Citadel Bulldogs": "#7badd3",
  "The College of New Jersey Lions": "#154c7d",
  "Thiel Tomcats": "#000000",
  "Thomas More Saints": "#000000",
  "Tiffin Dragons": "#000000",
  "Toledo Rockets": "#0b2240",
  "Towson Tigers": "#ffc229",
  "Trine Thunder": "#000000",
  "Trinity (CT) Bantams": "#032d58",
  "Trinity (TX) Tigers": "#000000",
  "Troy Trojans": "#862633",
  "Truman State Bulldogs": "#000000",
  "Tufts Jumbos": "#3e8ede",
  "Tulane Green Wave": "#006747",
  "Tulsa Golden Hurricane": "#003595",
  "Tusculum Pioneers": "#f2682a",
  "Tuskegee Golden Tigers": "#000000",
  "UAB": "#1a5632",
  "UAB Blazers": "#1a5632",
  "UALB": "#3d2777",
  "UAM": "#000000",
  "UAPB": "#e0aa0f",
  "UAlbany Great Danes": "#3d2777",
  "UC Davis Aggies": "#002855",
  "UCD": "#002855",
  "UCF": "#000000",
  "UCF Knights": "#000000",
  "UCLA": "#2774ae",
  "UCLA Bruins": "#2774ae",
  "UCM": "#000000",
  "UCO": "#000000",
  "UCWV": "#000000",
  "UConn Huskies": "#0c2340",
  "UF": "#000000",
  "UGA": "#ba0c2f",
  "UIU": "#000000",
  "UIW": "#000000",
  "UJ": "#000000",
  "UK": "#0033a0",
  "UL": "#ce181e",
  "UL Monroe Warhawks": "#840029",
  "ULM": "#840029",
  "ULV": "#004812",
  "UMD": "#000000",
  "UMMA": "#000000",
  "UMU": "#000000",
  "UMW": "#000000",
  "UMass Dartmouth Corsairs": "#000000",
  "UNA": "#000000",
  "UNC": "#7bafd4",
  "UNC Pembroke Braves": "#000000",
  "UNCO": "#13558d",
  "UNCP": "#000000",
  "UND": "#00a26b",
  "UNH": "#004990",
  "UNI": "#473282",
  "UNLV": "#cf0a2c",
  "UNLV Rebels": "#cf0a2c",
  "UNM": "#ba0c2f",
  "UNNY": "#762334",
  "UNT": "#068f33",
  "UNW": "#000000",
  "UOO": "#000000",
  "URI": "#091f3f",
  "URNY": "#000000",
  "URSN": "#98012e",
  "USA": "#00205b",
  "USC": "#9d2235",
  "USC Trojans": "#9d2235",
  "USCG": "#000000",
  "USD": "#2f99d4",
  "USF": "#006747",
  "USL": "#000000",
  "USM": "#ffc72c",
  "USU": "#0f2439",
  "UT Martin Skyhawks": "#ff6700",
  "UTAH": "#be0000",
  "UTC": "#00386b",
  "UTEP": "#ff8200",
  "UTEP Miners": "#ff8200",
  "UTIC": "#000000",
  "UTM": "#ff6700",
  "UTSA": "#0c2340",
  "UTSA Roadrunners": "#0c2340",
  "UTU": "#000000",
  "UVA": "#232d4b",
  "UVA Wise Cavaliers": "#e30000",
  "UVAW": "#e30000",
  "UWA": "#d31d33",
  "UWEC": "#000000",
  "UWL": "#000000",
  "UWO": "#000000",
  "UWP": "#000000",
  "UWRF": "#000000",
  "UWSP": "#000000",
  "UWST": "#000000",
  "UWW": "#000000",
  "Union Garnet Chargers": "#762334",
  "University of Mary Marauders": "#000000",
  "Upper Iowa Peacocks": "#000000",
  "Ursinus Bears": "#98012e",
  "Utah State Aggies": "#0f2439",
  "Utah Tech Trailblazers": "#000000",
  "Utah Utes": "#be0000",
  "Utica Pioneers": "#000000",
  "VAL": "#794500",
  "VALD": "#dd1a32",
  "VAN": "#000000",
  "VCSU": "#000000",
  "VILL": "#00205b",
  "VMI": "#ae122a",
  "VMI Keydets": "#ae122a",
  "VSU": "#000000",
  "VT": "#6a2c3e",
  "VTSC": "#000000",
  "VUU": "#000000",
  "Valdosta State Blazers": "#dd1a32",
  "Valley City State VALLEY CITY ST": "#000000",
  "Valparaiso Beacons": "#794500",
  "Vanderbilt Commodores": "#000000",
  "Vermont State Castleton Spartans": "#000000",
  "Villanova Wildcats": "#00205b",
  "Virginia Cavaliers": "#232d4b",
  "Virginia State Trojans": "#000000",
  "Virginia Tech Hokies": "#6a2c3e",
  "Virginia Union Panthers": "#000000",
  "W&J": "#000000",
  "W&L": "#000399",
  "W&M": "#115740",
  "WAB": "#000000",
  "WAG": "#00483a",
  "WAKE": "#ceb888",
  "WASH": "#33006f",
  "WAYN": "#000000",
  "WCHT": "#000000",
  "WCIL": "#000000",
  "WCMO": "#06496f",
  "WCOH": "#000000",
  "WCOL": "#000000",
  "WCPA": "#000000",
  "WCSU": "#002857",
  "WCU": "#492f91",
  "WEB": "#18005a",
  "WFST": "#1b509e",
  "WGA": "#0033a1",
  "WHIW": "#930036",
  "WHTR": "#4a217b",
  "WIDE": "#0056ba",
  "WILK": "#002856",
  "WINT": "#bf2f38",
  "WINU": "#182441",
  "WIS": "#a00000",
  "WITT": "#000000",
  "WIU": "#4e1e8a",
  "WJC": "#000000",
  "WKU": "#e13a3e",
  "WLC": "#006241",
  "WLDF": "#000000",
  "WLM": "#500082",
  "WLMT": "#960a2c",
  "WLSH": "#000000",
  "WLU": "#000000",
  "WMSN": "#000000",
  "WMU": "#532e1f",
  "WNE": "#000000",
  "WNMU": "#000000",
  "WNST": "#000000",
  "WOF": "#533b23",
  "WOO": "#000000",
  "WORC": "#004b8e",
  "WORU": "#000000",
  "WPEN": "#000000",
  "WPI": "#000000",
  "WPI Engineers": "#000000",
  "WPU": "#000000",
  "WSBN": "#000000",
  "WSCT": "#d72121",
  "WSMI": "#000000",
  "WSNE": "#000000",
  "WSSU": "#bb0100",
  "WSU": "#a60f2d",
  "WTAM": "#000000",
  "WTBG": "#f5822b",
  "WUMO": "#000000",
  "WVSU": "#000000",
  "WVU": "#eaaa00",
  "WVU Tech Golden Bears": "#000000",
  "WVUT": "#000000",
  "WVWC": "#000000",
  "WYO": "#492f24",
  "Wabash Little Giants": "#000000",
  "Wagner Seahawks": "#00483a",
  "Wake Forest Demon Deacons": "#ceb888",
  "Waldorf Warriors": "#000000",
  "Walsh Cavaliers": "#000000",
  "Wartburg Knights": "#f5822b",
  "Washburn Ichabods": "#000000",
  "Washington & Jefferson Presidents": "#000000",
  "Washington Huskies": "#33006f",
  "Washington St. Louis Bears": "#000000",
  "Washington State Cougars": "#a60f2d",
  "Washington and Lee Generals": "#000399",
  "Wayne State (MI) Warriors": "#000000",
  "Wayne State (NE) Wildcats": "#000000",
  "Waynesburg Yellow Jackets": "#000000",
  "Webber International Warriors": "#bf2f38",
  "Weber State Wildcats": "#18005a",
  "Wesleyan (CT) Cardinals": "#d72121",
  "West Alabama Tigers": "#d31d33",
  "West Chester Golden Rams": "#000000",
  "West Georgia Wolves": "#0033a1",
  "West Liberty Hilltoppers": "#000000",
  "West Texas Buffaloes": "#000000",
  "West Virginia Mountaineers": "#eaaa00",
  "West Virginia State Yellow Jackets": "#000000",
  "West Virginia Wesleyan Bobcats": "#000000",
  "Western Carolina Catamounts": "#492f91",
  "Western Colorado Mountaineers": "#000000",
  "Western Connecticut State Wolves": "#002857",
  "Western Illinois Leathernecks": "#4e1e8a",
  "Western Kentucky Hilltoppers": "#e13a3e",
  "Western Michigan Broncos": "#532e1f",
  "Western New England Golden Bears": "#000000",
  "Western New Mexico Mustangs": "#000000",
  "Western Oregon Wolves": "#000000",
  "Westfield State Owls": "#1b509e",
  "Westminster (MO) Blue Jays": "#06496f",
  "Westminster (PA) Titans": "#000000",
  "Wheaton (IL) Thunder": "#000000",
  "Whittier Poets": "#4a217b",
  "Whitworth Pirates": "#930036",
  "Widener Pride": "#0056ba",
  "Wilkes Colonels": "#002856",
  "Willamette Bearcats": "#960a2c",
  "William & Mary Tribe": "#115740",
  "William Jewell Cardinals": "#000000",
  "William Paterson Pioneers": "#000000",
  "William Penn Statesmen": "#000000",
  "Williams Ephs": "#500082",
  "Williamson Mechanics": "#000000",
  "Wilmington (OH) Fightin' Quakers": "#000000",
  "Wingate Bulldogs": "#182441",
  "Winona State Warriors": "#000000",
  "Winston-Salem State Rams": "#bb0100",
  "Wisconsin Badgers": "#a00000",
  "Wisconsin Eau Claire Blugolds": "#000000",
  "Wisconsin La Crosse Eagles": "#000000",
  "Wisconsin Lutheran Warriors": "#006241",
  "Wisconsin Oshkosh Titans": "#000000",
  "Wisconsin Platteville Pioneers": "#000000",
  "Wisconsin River Falls Falcons": "#000000",
  "Wisconsin Stevens Point Pointers": "#000000",
  "Wisconsin Stout Blue Devils": "#000000",
  "Wisconsin Whitewater Warhawks": "#000000",
  "Wittenberg Tigers": "#000000",
  "Wofford Terriers": "#533b23",
  "Wooster Fighting Scots": "#000000",
  "Worcester State Lancers": "#004b8e",
  "Wyoming Cowboys": "#492f24",
  "YALE": "#004a81",
  "YSU": "#e51936",
  "Yale Bulldogs": "#004a81",
  "Youngstown State Penguins": "#e51936",
}

const NCAAB_COLORS = {
  "AAMU": "#790000",
  "ACU": "#592d82",
  "AF": "#003594",
  "AKR": "#041e42",
  "ALA": "#9e1b32",
  "ALCN": "#4b0058",
  "ALST": "#e9a900",
  "AMCC": "#0067c5",
  "AMER": "#c41130",
  "APP": "#000000",
  "APSU": "#8e0b0b",
  "ARIZ": "#cc0033",
  "ARK": "#a32136",
  "ARMY": "#000000",
  "ARST": "#cc092f",
  "ASU": "#ffc627",
  "AUB": "#002b5c",
  "Abilene Christian Wildcats": "#592d82",
  "Air Force Falcons": "#003594",
  "Akron Zips": "#041e42",
  "Alabama A&M Bulldogs": "#790000",
  "Alabama Crimson Tide": "#9e1b32",
  "Alabama State Hornets": "#e9a900",
  "Alcorn State Braves": "#4b0058",
  "American University Eagles": "#c41130",
  "App State Mountaineers": "#000000",
  "Arizona State Sun Devils": "#ffc627",
  "Arizona Wildcats": "#cc0033",
  "Arkansas Razorbacks": "#a32136",
  "Arkansas State Red Wolves": "#cc092f",
  "Arkansas-Pine Bluff Golden Lions": "#e0aa0f",
  "Army Black Knights": "#000000",
  "Auburn Tigers": "#002b5c",
  "Austin Peay Governors": "#8e0b0b",
  "BALL": "#ba0c2f",
  "BAY": "#154734",
  "BC": "#8c2232",
  "BCU": "#7b1831",
  "BEL": "#182142",
  "BELL": "#000000",
  "BGSU": "#fd5000",
  "BING": "#00614a",
  "BOIS": "#0033a0",
  "BRAD": "#b70002",
  "BRWN": "#411e09",
  "BRY": "#000000",
  "BTLR": "#0d1361",
  "BU": "#cc0000",
  "BUCK": "#000060",
  "BUF": "#005bbb",
  "BYU": "#0047ba",
  "BYU Cougars": "#0047ba",
  "Ball State Cardinals": "#ba0c2f",
  "Baylor Bears": "#154734",
  "Bellarmine Knights": "#000000",
  "Belmont Bruins": "#182142",
  "Bethune-Cookman Wildcats": "#7b1831",
  "Binghamton Bearcats": "#00614a",
  "Boise State Broncos": "#0033a0",
  "Boston College Eagles": "#8c2232",
  "Boston University Terriers": "#cc0000",
  "Bowling Green Falcons": "#fd5000",
  "Bradley Braves": "#b70002",
  "Brown Bears": "#411e09",
  "Bryant Bulldogs": "#000000",
  "Bucknell Bison": "#000060",
  "Buffalo Bulls": "#005bbb",
  "Butler Bulldogs": "#0d1361",
  "CAL": "#041e42",
  "CAM": "#000000",
  "CAN": "#004a81",
  "CARK": "#a7a9ac",
  "CBU": "#000080",
  "CCSU": "#1b49a2",
  "CCU": "#006f71",
  "CHSO": "#2e3192",
  "CHST": "#006700",
  "CIN": "#000000",
  "CIT": "#7badd3",
  "CLE": "#006633",
  "CLEM": "#f56600",
  "CLT": "#005035",
  "CMU": "#4c0027",
  "COFC": "#7a2531",
  "COLG": "#821019",
  "COLO": "#cfb87c",
  "COLU": "#7ba4db",
  "CONN": "#0c2340",
  "COPP": "#2e3192",
  "COR": "#b31b1b",
  "CP": "#1e4d2b",
  "CREI": "#005ca9",
  "CSU": "#004c23",
  "CSUB": "#003bab",
  "CSUF": "#003767",
  "CSUN": "#b50000",
  "Cal Poly Mustangs": "#1e4d2b",
  "Cal State Bakersfield Roadrunners": "#003bab",
  "Cal State Fullerton Titans": "#003767",
  "Cal State Northridge Matadors": "#b50000",
  "California Baptist Lancers": "#000080",
  "California Golden Bears": "#041e42",
  "Campbell Fighting Camels": "#000000",
  "Canisius Golden Griffins": "#004a81",
  "Central Arkansas Bears": "#a7a9ac",
  "Central Connecticut Blue Devils": "#1b49a2",
  "Central Michigan Chippewas": "#4c0027",
  "Charleston Cougars": "#7a2531",
  "Charleston Southern Buccaneers": "#2e3192",
  "Charlotte 49ers": "#005035",
  "Chattanooga Mocs": "#00386b",
  "Chicago State Cougars": "#006700",
  "Cincinnati Bearcats": "#000000",
  "Clemson Tigers": "#f56600",
  "Cleveland State Vikings": "#006633",
  "Coastal Carolina Chanticleers": "#006f71",
  "Colgate Raiders": "#821019",
  "Colorado Buffaloes": "#cfb87c",
  "Colorado State Rams": "#004c23",
  "Columbia Lions": "#7ba4db",
  "Coppin State Eagles": "#2e3192",
  "Cornell Big Red": "#b31b1b",
  "Creighton Bluejays": "#005ca9",
  "DART": "#005730",
  "DAV": "#000000",
  "DAY": "#004b8d",
  "DEL": "#00539f",
  "DEN": "#98002e",
  "DEP": "#2d649c",
  "DETM": "#165b9e",
  "DREX": "#020260",
  "DRKE": "#005596",
  "DSU": "#009cdb",
  "DUKE": "#00539b",
  "DUQ": "#002d62",
  "Dartmouth Big Green": "#005730",
  "Davidson Wildcats": "#000000",
  "Dayton Flyers": "#004b8d",
  "DePaul Blue Demons": "#2d649c",
  "Delaware Blue Hens": "#00539f",
  "Delaware State Hornets": "#009cdb",
  "Denver Pioneers": "#98002e",
  "Detroit Mercy Titans": "#165b9e",
  "Drake Bulldogs": "#005596",
  "Drexel Dragons": "#020260",
  "Duke Blue Devils": "#00539b",
  "Duquesne Dukes": "#002d62",
  "ECU": "#582c83",
  "EIU": "#000000",
  "EKU": "#660819",
  "ELON": "#020303",
  "EMU": "#006938",
  "ETAM": "#000000",
  "ETSU": "#002d61",
  "EVAN": "#663399",
  "EWU": "#a10022",
  "East Carolina Pirates": "#582c83",
  "East Tennessee State Buccaneers": "#002d61",
  "East Texas A&M Lions": "#000000",
  "Eastern Illinois Panthers": "#000000",
  "Eastern Kentucky Colonels": "#660819",
  "Eastern Michigan Eagles": "#006938",
  "Eastern Washington Eagles": "#a10022",
  "Elon Phoenix": "#020303",
  "Evansville Purple Aces": "#663399",
  "FAIR": "#000000",
  "FAMU": "#f89728",
  "FAU": "#003366",
  "FDU": "#72293c",
  "FGCU": "#00885a",
  "FIU": "#091f3f",
  "FLA": "#0021a5",
  "FOR": "#830032",
  "FRES": "#b1102b",
  "FSU": "#782f40",
  "FUR": "#582c83",
  "Fairfield Stags": "#000000",
  "Fairleigh Dickinson Knights": "#72293c",
  "Florida A&M Rattlers": "#f89728",
  "Florida Atlantic Owls": "#003366",
  "Florida Gators": "#0021a5",
  "Florida Gulf Coast Eagles": "#00885a",
  "Florida International Panthers": "#091f3f",
  "Florida State Seminoles": "#782f40",
  "Fordham Rams": "#830032",
  "Fresno State Bulldogs": "#b1102b",
  "Furman Paladins": "#582c83",
  "GASO": "#041e42",
  "GAST": "#0039a6",
  "GB": "#006633",
  "GCU": "#522398",
  "GMU": "#016600",
  "GONZ": "#041e42",
  "GRAM": "#ee8601",
  "GT": "#b3a369",
  "GTWN": "#110e42",
  "GW": "#002843",
  "GWEB": "#c12535",
  "Gardner-Webb Runnin' Bulldogs": "#c12535",
  "George Mason Patriots": "#016600",
  "George Washington Revolutionaries": "#002843",
  "Georgetown Hoyas": "#110e42",
  "Georgia Bulldogs": "#ba0c2f",
  "Georgia Southern Eagles": "#041e42",
  "Georgia State Panthers": "#0039a6",
  "Georgia Tech Yellow Jackets": "#b3a369",
  "Gonzaga Bulldogs": "#041e42",
  "Grambling Tigers": "#ee8601",
  "Grand Canyon Lopes": "#522398",
  "Green Bay Phoenix": "#006633",
  "HALL": "#0857b1",
  "HAMP": "#0067ac",
  "HARV": "#990000",
  "HAW": "#005737",
  "HC": "#582c83",
  "HCU": "#00539c",
  "HOF": "#003594",
  "HOU": "#c8102e",
  "HOW": "#003a63",
  "HPU": "#330072",
  "Hampton Pirates": "#0067ac",
  "Harvard Crimson": "#990000",
  "Hawai'i Rainbow Warriors": "#005737",
  "High Point Panthers": "#330072",
  "Hofstra Pride": "#003594",
  "Holy Cross Crusaders": "#582c83",
  "Houston Christian Huskies": "#00539c",
  "Houston Cougars": "#c8102e",
  "Howard Bison": "#003a63",
  "IDHO": "#000000",
  "IDST": "#ef8c00",
  "ILL": "#ff5f05",
  "ILST": "#ce1126",
  "INST": "#00669a",
  "IONA": "#6f2c3e",
  "IOWA": "#231f20",
  "ISU": "#ae192d",
  "IU": "#970310",
  "IU Indianapolis Jaguars": "#a81f30",
  "IUIN": "#a81f30",
  "Idaho State Bengals": "#ef8c00",
  "Idaho Vandals": "#000000",
  "Illinois Fighting Illini": "#ff5f05",
  "Illinois State Redbirds": "#ce1126",
  "Incarnate Word Cardinals": "#000000",
  "Indiana Hoosiers": "#970310",
  "Indiana State Sycamores": "#00669a",
  "Iona Gaels": "#6f2c3e",
  "Iowa Hawkeyes": "#231f20",
  "Iowa State Cyclones": "#ae192d",
  "JAX": "#00523e",
  "JKST": "#123297",
  "JMU": "#450084",
  "JOES": "#9e1b32",
  "JXST": "#cc0000",
  "Jackson State Tigers": "#123297",
  "Jacksonville Dolphins": "#00523e",
  "Jacksonville State Gamecocks": "#cc0000",
  "James Madison Dukes": "#450084",
  "KC": "#004b87",
  "KENN": "#fdbb30",
  "KENT": "#002664",
  "KSU": "#330a57",
  "KU": "#0051ba",
  "Kansas City Roos": "#004b87",
  "Kansas Jayhawks": "#0051ba",
  "Kansas State Wildcats": "#330a57",
  "Kennesaw State Owls": "#fdbb30",
  "Kent State Golden Flashes": "#002664",
  "Kentucky Wildcats": "#0033a0",
  "L-MD": "#76a7a0",
  "LAF": "#790000",
  "LAM": "#000000",
  "LAS": "#003356",
  "LBSU": "#000000",
  "LEH": "#6c2b2a",
  "LIB": "#0a254e",
  "LIP": "#20366c",
  "LIU": "#50c9f7",
  "LMU": "#880029",
  "LONG": "#003273",
  "LOU": "#c9001f",
  "LR": "#ad0000",
  "LSU": "#461d76",
  "LSU New Orleans Privateers": "#005da6",
  "LSU Tigers": "#461d76",
  "LT": "#003087",
  "LUC": "#9d1244",
  "La Salle Explorers": "#003356",
  "Lafayette Leopards": "#790000",
  "Lamar Cardinals": "#000000",
  "Lehigh Mountain Hawks": "#6c2b2a",
  "Liberty Flames": "#0a254e",
  "Lipscomb Bisons": "#20366c",
  "Little Rock Trojans": "#ad0000",
  "Long Beach State Beach": "#000000",
  "Long Island University Sharks": "#50c9f7",
  "Longwood Lancers": "#003273",
  "Louisiana Ragin' Cajuns": "#ce181e",
  "Louisiana Tech Bulldogs": "#003087",
  "Louisville Cardinals": "#c9001f",
  "Loyola Chicago Ramblers": "#9d1244",
  "Loyola Maryland Greyhounds": "#76a7a0",
  "Loyola Marymount Lions": "#880029",
  "M-OH": "#c41230",
  "MAN": "#4f8537",
  "MARQ": "#003366",
  "MASS": "#881c1c",
  "MCN": "#00529c",
  "MD": "#ce1126",
  "ME": "#127dbe",
  "MEM": "#004991",
  "MER": "#ff7f29",
  "MERC": "#000000",
  "MIA": "#f47423",
  "MICH": "#00274c",
  "MILW": "#000000",
  "MINN": "#5e0a2f",
  "MISS": "#13294b",
  "MIZ": "#f1b82d",
  "MONM": "#051844",
  "MONT": "#751d4a",
  "MORE": "#094fa3",
  "MORG": "#014786",
  "MOST": "#5e0009",
  "MRMK": "#2f4f93",
  "MRSH": "#00b140",
  "MRST": "#e53730",
  "MSM": "#005596",
  "MSST": "#5d1725",
  "MSU": "#173f35",
  "MTST": "#00205c",
  "MTSU": "#036eb7",
  "MUR": "#002148",
  "MVSU": "#005328",
  "Maine Black Bears": "#127dbe",
  "Manhattan Jaspers": "#4f8537",
  "Marist Red Foxes": "#e53730",
  "Marquette Golden Eagles": "#003366",
  "Marshall Thundering Herd": "#00b140",
  "Maryland Eastern Shore Hawks": "#5c2301",
  "Maryland Terrapins": "#ce1126",
  "Massachusetts Minutemen": "#881c1c",
  "UMass Minutemen": "#881c1c",
  "UMass": "#881c1c",
  "McNeese Cowboys": "#00529c",
  "Memphis Tigers": "#004991",
  "Mercer Bears": "#ff7f29",
  "Mercyhurst Lakers": "#000000",
  "Merrimack Warriors": "#2f4f93",
  "Miami (OH) RedHawks": "#c41230",
  "Miami Hurricanes": "#f47423",
  "Michigan State Spartans": "#173f35",
  "Michigan Wolverines": "#00274c",
  "Middle Tennessee Blue Raiders": "#036eb7",
  "Milwaukee Panthers": "#000000",
  "Minnesota Golden Gophers": "#5e0a2f",
  "Mississippi State Bulldogs": "#5d1725",
  "Mississippi Valley State Delta Devils": "#005328",
  "Missouri State Bears": "#5e0009",
  "Missouri Tigers": "#f1b82d",
  "Monmouth Hawks": "#051844",
  "Montana Grizzlies": "#751d4a",
  "Montana State Bobcats": "#00205c",
  "Morehead State Eagles": "#094fa3",
  "Morgan State Bears": "#014786",
  "Mount St. Mary's Mountaineers": "#005596",
  "Murray State Racers": "#002148",
  "NAU": "#003976",
  "NAVY": "#00225b",
  "NC State Wolfpack": "#cc0000",
  "NCAT": "#0505aa",
  "NCCU": "#880023",
  "NCSU": "#cc0000",
  "ND": "#062340",
  "NDSU": "#01402a",
  "NE": "#cc0001",
  "NEB": "#e31937",
  "NEV": "#041e42",
  "NHVN": "#041e42",
  "NIA": "#69207e",
  "NICH": "#c41230",
  "NIU": "#c8102e",
  "NJIT": "#ee3024",
  "NJIT Highlanders": "#ee3024",
  "NKU": "#ffc82e",
  "NMSU": "#7e141b",
  "NOLA": "#005da6",
  "NORF": "#0c8968",
  "NU": "#492f92",
  "NWST": "#492f91",
  "Navy Midshipmen": "#00225b",
  "Nebraska Cornhuskers": "#e31937",
  "Nevada Wolf Pack": "#041e42",
  "New Hampshire Wildcats": "#004990",
  "New Haven Chargers": "#041e42",
  "New Mexico Lobos": "#ba0c2f",
  "New Mexico State Aggies": "#7e141b",
  "Niagara Purple Eagles": "#69207e",
  "Nicholls Colonels": "#c41230",
  "Norfolk State Spartans": "#0c8968",
  "North Alabama Lions": "#663399",
  "North Carolina A&T Aggies": "#0505aa",
  "North Carolina Central Eagles": "#880023",
  "North Carolina Tar Heels": "#7bafd4",
  "North Dakota Fighting Hawks": "#00a26b",
  "North Dakota State Bison": "#01402a",
  "North Florida Ospreys": "#004b8d",
  "North Texas Mean Green": "#068f33",
  "Northeastern Huskies": "#cc0001",
  "Northern Arizona Lumberjacks": "#003976",
  "Northern Colorado Bears": "#13558d",
  "Northern Illinois Huskies": "#c8102e",
  "Northern Iowa Panthers": "#473282",
  "Northern Kentucky Norse": "#ffc82e",
  "Northwestern State Demons": "#492f91",
  "Northwestern Wildcats": "#492f92",
  "Notre Dame Fighting Irish": "#062340",
  "OAK": "#04091c",
  "ODU": "#003768",
  "OHIO": "#154734",
  "OKST": "#fe5c00",
  "OMA": "#e3193e",
  "ORE": "#00934b",
  "ORST": "#dc4405",
  "ORU": "#002462",
  "OSU": "#ba0c2f",
  "OU": "#990000",
  "Oakland Golden Grizzlies": "#04091c",
  "Ohio Bobcats": "#154734",
  "Ohio State Buckeyes": "#ba0c2f",
  "Oklahoma Sooners": "#990000",
  "Oklahoma State Cowboys": "#fe5c00",
  "Old Dominion Monarchs": "#003768",
  "Ole Miss Rebels": "#13294b",
  "Omaha Mavericks": "#e3193e",
  "Oral Roberts Golden Eagles": "#002462",
  "Oregon Ducks": "#00934b",
  "Oregon State Beavers": "#dc4405",
  "PAC": "#f47820",
  "PENN": "#082a74",
  "PEPP": "#003a72",
  "PFW": "#cfb991",
  "PITT": "#003594",
  "PORT": "#330072",
  "PRES": "#194896",
  "PRIN": "#000000",
  "PROV": "#000000",
  "PRST": "#00311e",
  "PSU": "#061440",
  "PUR": "#ceb888",
  "PV": "#582c83",
  "Pacific Tigers": "#f47820",
  "Penn State Nittany Lions": "#061440",
  "Pennsylvania Quakers": "#082a74",
  "Pepperdine Waves": "#003a72",
  "Pittsburgh Panthers": "#003594",
  "Portland Pilots": "#330072",
  "Portland State Vikings": "#00311e",
  "Prairie View A&M Panthers": "#582c83",
  "Presbyterian Blue Hose": "#194896",
  "Princeton Tigers": "#000000",
  "Providence Friars": "#000000",
  "Purdue Boilermakers": "#ceb888",
  "Purdue Fort Wayne Mastodons": "#cfb991",
  "QUIN": "#041b43",
  "Quinnipiac Bobcats": "#041b43",
  "RAD": "#bc1515",
  "RGV": "#dc6000",
  "RICE": "#00205b",
  "RICH": "#9e0712",
  "RID": "#a80532",
  "RMU": "#00214d",
  "RUTG": "#ce0e2d",
  "Radford Highlanders": "#bc1515",
  "Rhode Island Rams": "#091f3f",
  "Rice Owls": "#00205b",
  "Richmond Spiders": "#9e0712",
  "Rider Broncs": "#a80532",
  "Robert Morris Colonials": "#00214d",
  "Rutgers Scarlet Knights": "#ce0e2d",
  "SAC": "#00573c",
  "SAM": "#005485",
  "SBU": "#70261d",
  "SC": "#73000a",
  "SCST": "#7d1315",
  "SCU": "#690b0b",
  "SDAK": "#cd1241",
  "SDST": "#0033a0",
  "SDSU": "#a6192e",
  "SE Louisiana Lions": "#215732",
  "SEA": "#bf2e1a",
  "SELA": "#215732",
  "SEMO": "#c8102e",
  "SF": "#005a36",
  "SFA": "#393996",
  "SHSU": "#f56423",
  "SHU": "#a40012",
  "SIE": "#037961",
  "SIU": "#85283d",
  "SIU Edwardsville Cougars": "#eb1c23",
  "SIUE": "#eb1c23",
  "SJSU": "#0038a8",
  "SJU": "#d10000",
  "SLU": "#00539c",
  "SMC": "#d80024",
  "SMU": "#a80000",
  "SMU Mustangs": "#a80000",
  "SOU": "#004b97",
  "SPU": "#004cc2",
  "STAN": "#8c1515",
  "STBK": "#990000",
  "STET": "#0a5640",
  "STMN": "#000000",
  "STO": "#000000",
  "SUU": "#c72026",
  "SYR": "#000e54",
  "Sacramento State Hornets": "#00573c",
  "Sacred Heart Pioneers": "#a40012",
  "Saint Joseph's Hawks": "#9e1b32",
  "Saint Louis Billikens": "#00539c",
  "Saint Mary's Gaels": "#d80024",
  "Saint Peter's Peacocks": "#004cc2",
  "Sam Houston Bearkats": "#f56423",
  "Samford Bulldogs": "#005485",
  "San Diego State Aztecs": "#a6192e",
  "San Diego Toreros": "#2f99d4",
  "San Francisco Dons": "#005a36",
  "San José State Spartans": "#0038a8",
  "Santa Clara Broncos": "#690b0b",
  "Seattle U Redhawks": "#bf2e1a",
  "Seton Hall Pirates": "#0857b1",
  "Siena Saints": "#037961",
  "South Alabama Jaguars": "#00205b",
  "South Carolina Gamecocks": "#73000a",
  "South Carolina State Bulldogs": "#7d1315",
  "South Carolina Upstate Spartans": "#008545",
  "South Dakota Coyotes": "#cd1241",
  "South Dakota State Jackrabbits": "#0033a0",
  "South Florida Bulls": "#006747",
  "Southeast Missouri State Redhawks": "#c8102e",
  "Southern Illinois Salukis": "#85283d",
  "Southern Jaguars": "#004b97",
  "Southern Miss Golden Eagles": "#ffc72c",
  "Southern Utah Thunderbirds": "#c72026",
  "St. Bonaventure Bonnies": "#70261d",
  "St. John's Red Storm": "#d10000",
  "St. Thomas Tommies": "#000000",
  "Stanford Cardinal": "#8c1515",
  "Stephen F. Austin Lumberjacks": "#393996",
  "Stetson Hatters": "#0a5640",
  "Stonehill Skyhawks": "#000000",
  "Stony Brook Seawolves": "#990000",
  "Syracuse Orange": "#000e54",
  "TA&M": "#500000",
  "TAR": "#000000",
  "TCU": "#4d1979",
  "TCU Horned Frogs": "#4d1979",
  "TEM": "#a41e35",
  "TENN": "#ff8200",
  "TEX": "#af5c37",
  "TLSA": "#003595",
  "TNST": "#171796",
  "TNTC": "#5a4099",
  "TOL": "#0b2240",
  "TOW": "#ffc229",
  "TROY": "#862633",
  "TTU": "#da291c",
  "TULN": "#006747",
  "TXSO": "#860038",
  "TXST": "#501214",
  "Tarleton State Texans": "#000000",
  "Temple Owls": "#a41e35",
  "Tennessee State Tigers": "#171796",
  "Tennessee Tech Golden Eagles": "#5a4099",
  "Tennessee Volunteers": "#ff8200",
  "Texas A&M Aggies": "#500000",
  "Texas A&M-Corpus Christi Islanders": "#0067c5",
  "Texas Longhorns": "#af5c37",
  "Texas Southern Tigers": "#860038",
  "Texas State Bobcats": "#501214",
  "Texas Tech Red Raiders": "#da291c",
  "The Citadel Bulldogs": "#7badd3",
  "Toledo Rockets": "#0b2240",
  "Towson Tigers": "#ffc229",
  "Troy Trojans": "#862633",
  "Tulane Green Wave": "#006747",
  "Tulsa Golden Hurricane": "#003595",
  "UAB": "#1a5632",
  "UAB Blazers": "#1a5632",
  "UALB": "#3d2777",
  "UAPB": "#e0aa0f",
  "UAlbany Great Danes": "#3d2777",
  "UC Davis Aggies": "#002855",
  "UC Irvine Anteaters": "#002b5c",
  "UC Riverside Highlanders": "#14234f",
  "UC San Diego Tritons": "#000000",
  "UC Santa Barbara Gauchos": "#1e1840",
  "UCD": "#002855",
  "UCF": "#000000",
  "UCF Knights": "#000000",
  "UCI": "#002b5c",
  "UCLA": "#2774ae",
  "UCLA Bruins": "#2774ae",
  "UCR": "#14234f",
  "UCSB": "#1e1840",
  "UCSD": "#000000",
  "UConn Huskies": "#0c2340",
  "UGA": "#ba0c2f",
  "UIC": "#001e62",
  "UIC Flames": "#001e62",
  "UIW": "#000000",
  "UK": "#0033a0",
  "UL": "#ce181e",
  "UL Monroe Warhawks": "#840029",
  "ULM": "#840029",
  "UMBC": "#000000",
  "UMBC Retrievers": "#000000",
  "UMES": "#5c2301",
  "UML": "#00529c",
  "UMass Lowell River Hawks": "#00529c",
  "UNA": "#663399",
  "UNC": "#7bafd4",
  "UNC Asheville Bulldogs": "#003da5",
  "UNC Greensboro Spartans": "#003559",
  "UNC Wilmington Seahawks": "#00665e",
  "UNCA": "#003da5",
  "UNCG": "#003559",
  "UNCO": "#13558d",
  "UNCW": "#00665e",
  "UND": "#00a26b",
  "UNF": "#004b8d",
  "UNH": "#004990",
  "UNI": "#473282",
  "UNLV": "#cf0a2c",
  "UNLV Rebels": "#cf0a2c",
  "UNM": "#ba0c2f",
  "UNT": "#068f33",
  "UPST": "#008545",
  "URI": "#091f3f",
  "USA": "#00205b",
  "USC": "#9d2235",
  "USC Trojans": "#9d2235",
  "USD": "#2f99d4",
  "USF": "#006747",
  "USM": "#ffc72c",
  "USU": "#0f2439",
  "UT Arlington Mavericks": "#004b7c",
  "UT Martin Skyhawks": "#ff6700",
  "UT Rio Grande Valley Vaqueros": "#dc6000",
  "UTA": "#004b7c",
  "UTAH": "#be0000",
  "UTC": "#00386b",
  "UTEP": "#ff8200",
  "UTEP Miners": "#ff8200",
  "UTM": "#ff6700",
  "UTSA": "#0c2340",
  "UTSA Roadrunners": "#0c2340",
  "UTU": "#000000",
  "UVA": "#232d4b",
  "UVM": "#154734",
  "UVU": "#004812",
  "Utah State Aggies": "#0f2439",
  "Utah Tech Trailblazers": "#000000",
  "Utah Utes": "#be0000",
  "Utah Valley Wolverines": "#004812",
  "VAL": "#794500",
  "VAN": "#000000",
  "VCU": "#ffaf00",
  "VCU Rams": "#ffaf00",
  "VILL": "#00205b",
  "VMI": "#ae122a",
  "VMI Keydets": "#ae122a",
  "VT": "#6a2c3e",
  "Valparaiso Beacons": "#794500",
  "Vanderbilt Commodores": "#000000",
  "Vermont Catamounts": "#154734",
  "Villanova Wildcats": "#00205b",
  "Virginia Cavaliers": "#232d4b",
  "Virginia Tech Hokies": "#6a2c3e",
  "W&M": "#115740",
  "WAG": "#00483a",
  "WAKE": "#ceb888",
  "WASH": "#33006f",
  "WCU": "#492f91",
  "WEB": "#18005a",
  "WFL": "#087dc2",
  "WGA": "#0033a1",
  "WICH": "#ffcd00",
  "WIN": "#9e0b0e",
  "WIS": "#a00000",
  "WIU": "#4e1e8a",
  "WKU": "#e13a3e",
  "WMU": "#532e1f",
  "WOF": "#533b22",
  "WRST": "#cba052",
  "WSU": "#a60f2d",
  "WVU": "#eaaa00",
  "WYO": "#492f24",
  "Wagner Seahawks": "#00483a",
  "Wake Forest Demon Deacons": "#ceb888",
  "Washington Huskies": "#33006f",
  "Washington State Cougars": "#a60f2d",
  "Weber State Wildcats": "#18005a",
  "West Florida Argonauts": "#087dc2",
  "West Georgia Wolves": "#0033a1",
  "West Virginia Mountaineers": "#eaaa00",
  "Western Carolina Catamounts": "#492f91",
  "Western Illinois Leathernecks": "#4e1e8a",
  "Western Kentucky Hilltoppers": "#e13a3e",
  "Western Michigan Broncos": "#532e1f",
  "Wichita State Shockers": "#ffcd00",
  "William & Mary Tribe": "#115740",
  "Winthrop Eagles": "#9e0b0e",
  "Wisconsin Badgers": "#a00000",
  "Wofford Terriers": "#533b22",
  "Wright State Raiders": "#cba052",
  "Wyoming Cowboys": "#492f24",
  "XAV": "#21304e",
  "Xavier Musketeers": "#21304e",
  "YALE": "#004a81",
  "YSU": "#e51935",
  "Yale Bulldogs": "#004a81",
  "Youngstown State Penguins": "#e51935",
}

const WNCAAB_COLORS = {
  "AAMU": "#790000",
  "ACU": "#592d82",
  "AF": "#003594",
  "AKR": "#041e42",
  "ALA": "#9e1b32",
  "ALCN": "#4b0058",
  "ALST": "#e9a900",
  "AMCC": "#0067c5",
  "AMER": "#c41130",
  "APP": "#000000",
  "APSU": "#8e0b0b",
  "ARIZ": "#cc0033",
  "ARK": "#a32136",
  "ARMY": "#000000",
  "ARST": "#cc092f",
  "ASU": "#ffc627",
  "AUB": "#002b5c",
  "Abilene Christian Wildcats": "#592d82",
  "Air Force Falcons": "#003594",
  "Akron Zips": "#041e42",
  "Alabama A&M Bulldogs": "#790000",
  "Alabama Crimson Tide": "#9e1b32",
  "Alabama State Lady Hornets": "#e9a900",
  "Alcorn State Lady Braves": "#4b0058",
  "American University Eagles": "#c41130",
  "App State Mountaineers": "#000000",
  "Arizona State Sun Devils": "#ffc627",
  "Arizona Wildcats": "#cc0033",
  "Arkansas Razorbacks": "#a32136",
  "Arkansas State Red Wolves": "#cc092f",
  "Arkansas-Pine Bluff Golden Lions": "#e0aa0f",
  "Army Black Knights": "#000000",
  "Auburn Tigers": "#002b5c",
  "Austin Peay Governors": "#8e0b0b",
  "BALL": "#ba0c2f",
  "BAY": "#154734",
  "BC": "#8c2232",
  "BCU": "#7b1831",
  "BEL": "#182142",
  "BELL": "#000000",
  "BGSU": "#fd5000",
  "BING": "#00614a",
  "BOIS": "#0033a0",
  "BRAD": "#b70002",
  "BRWN": "#411e09",
  "BRY": "#000000",
  "BTLR": "#0d1361",
  "BU": "#cc0000",
  "BUCK": "#000060",
  "BUF": "#005bbb",
  "BYU": "#0047ba",
  "BYU Cougars": "#0047ba",
  "Ball State Cardinals": "#ba0c2f",
  "Baylor Bears": "#154734",
  "Bellarmine Knights": "#000000",
  "Belmont Bruins": "#182142",
  "Bethune-Cookman Wildcats": "#7b1831",
  "Binghamton Bearcats": "#00614a",
  "Boise State Broncos": "#0033a0",
  "Boston College Eagles": "#8c2232",
  "Boston University Terriers": "#cc0000",
  "Bowling Green Falcons": "#fd5000",
  "Bradley Braves": "#b70002",
  "Brown Bears": "#411e09",
  "Bryant Bulldogs": "#000000",
  "Bucknell Bison": "#000060",
  "Buffalo Bulls": "#005bbb",
  "Butler Bulldogs": "#0d1361",
  "CAL": "#041e42",
  "CAM": "#000000",
  "CAN": "#004a81",
  "CARK": "#a7a9ac",
  "CBU": "#000000",
  "CCSU": "#1b49a2",
  "CCU": "#006f71",
  "CHSO": "#2e3192",
  "CHST": "#006700",
  "CIN": "#000000",
  "CLE": "#006633",
  "CLEM": "#f56600",
  "CLT": "#005035",
  "CMU": "#4c0027",
  "COFC": "#7a2531",
  "COLG": "#821019",
  "COLO": "#cfb87c",
  "COLU": "#7ba4db",
  "CONN": "#0c2340",
  "COPP": "#2e3192",
  "COR": "#b31b1b",
  "CP": "#1e4d2b",
  "CREI": "#005ca9",
  "CSU": "#004c23",
  "CSUB": "#003bab",
  "CSUF": "#003767",
  "CSUN": "#b50000",
  "Cal Poly Mustangs": "#1e4d2b",
  "Cal State Bakersfield Roadrunners": "#003bab",
  "Cal State Fullerton Titans": "#003767",
  "Cal State Northridge Matadors": "#b50000",
  "California Baptist Lancers": "#000000",
  "California Golden Bears": "#041e42",
  "Campbell Fighting Camels": "#000000",
  "Canisius Golden Griffins": "#004a81",
  "Central Arkansas Bears": "#a7a9ac",
  "Central Connecticut Blue Devils": "#1b49a2",
  "Central Michigan Chippewas": "#4c0027",
  "Charleston Cougars": "#7a2531",
  "Charleston Southern Buccaneers": "#2e3192",
  "Charlotte 49ers": "#005035",
  "Chattanooga Mocs": "#00386b",
  "Chicago State Cougars": "#006700",
  "Cincinnati Bearcats": "#000000",
  "Clemson Tigers": "#f56600",
  "Cleveland State Vikings": "#006633",
  "Coastal Carolina Chanticleers": "#006f71",
  "Colgate Raiders": "#821019",
  "Colorado Buffaloes": "#cfb87c",
  "Colorado State Rams": "#004c23",
  "Columbia Lions": "#7ba4db",
  "Coppin State Eagles": "#2e3192",
  "Cornell Big Red": "#b31b1b",
  "Creighton Bluejays": "#005ca9",
  "DART": "#005730",
  "DAV": "#000000",
  "DAY": "#004b8d",
  "DEL": "#00539f",
  "DEN": "#98002e",
  "DEP": "#2d649c",
  "DETM": "#165b9e",
  "DREX": "#020260",
  "DRKE": "#005596",
  "DSU": "#009cdb",
  "DUKE": "#00539b",
  "DUQ": "#002d62",
  "Dartmouth Big Green": "#005730",
  "Davidson Wildcats": "#000000",
  "Dayton Flyers": "#004b8d",
  "DePaul Blue Demons": "#2d649c",
  "Delaware Blue Hens": "#00539f",
  "Delaware State Hornets": "#009cdb",
  "Denver Pioneers": "#98002e",
  "Detroit Mercy Titans": "#165b9e",
  "Drake Bulldogs": "#005596",
  "Drexel Dragons": "#020260",
  "Duke Blue Devils": "#00539b",
  "Duquesne Dukes": "#002d62",
  "ECU": "#582c83",
  "EIU": "#000000",
  "EKU": "#660819",
  "ELON": "#020303",
  "EMU": "#006938",
  "ETAM": "#000000",
  "ETSU": "#002d61",
  "EVAN": "#663399",
  "EWU": "#a10022",
  "East Carolina Pirates": "#582c83",
  "East Tennessee State Bucs": "#002d61",
  "East Texas A&M Lions": "#000000",
  "Eastern Illinois Panthers": "#000000",
  "Eastern Kentucky Colonels": "#660819",
  "Eastern Michigan Eagles": "#006938",
  "Eastern Washington Eagles": "#a10022",
  "Elon Phoenix": "#020303",
  "Evansville Purple Aces": "#663399",
  "FAIR": "#000000",
  "FAMU": "#f89728",
  "FAU": "#003366",
  "FDU": "#72293c",
  "FGCU": "#00885a",
  "FIU": "#091f3f",
  "FLA": "#0021a5",
  "FOR": "#830032",
  "FRES": "#b1102b",
  "FSU": "#782f40",
  "FUR": "#582c83",
  "Fairfield Stags": "#000000",
  "Fairleigh Dickinson Knights": "#72293c",
  "Florida A&M Rattlers": "#f89728",
  "Florida Atlantic Owls": "#003366",
  "Florida Gators": "#0021a5",
  "Florida Gulf Coast Eagles": "#00885a",
  "Florida International Panthers": "#091f3f",
  "Florida State Seminoles": "#782f40",
  "Fordham Rams": "#830032",
  "Fresno State Bulldogs": "#b1102b",
  "Furman Paladins": "#582c83",
  "GASO": "#041e42",
  "GAST": "#0039a6",
  "GB": "#006633",
  "GCU": "#522398",
  "GMU": "#016600",
  "GONZ": "#041e42",
  "GRAM": "#ee8601",
  "GT": "#b3a369",
  "GTWN": "#110e42",
  "GW": "#002843",
  "GWEB": "#c12535",
  "Gardner-Webb Runnin' Bulldogs": "#c12535",
  "George Mason Patriots": "#016600",
  "George Washington Revolutionaries": "#002843",
  "Georgetown Hoyas": "#110e42",
  "Georgia Lady Bulldogs": "#ba0c2f",
  "Georgia Southern Eagles": "#041e42",
  "Georgia State Panthers": "#0039a6",
  "Georgia Tech Yellow Jackets": "#b3a369",
  "Gonzaga Bulldogs": "#041e42",
  "Grambling Lady Tigers": "#ee8601",
  "Grand Canyon Lopes": "#522398",
  "Green Bay Phoenix": "#006633",
  "HALL": "#0857b1",
  "HAMP": "#0067ac",
  "HARV": "#990000",
  "HAW": "#005737",
  "HC": "#582c83",
  "HCU": "#00539c",
  "HOF": "#003594",
  "HOU": "#c8102e",
  "HOW": "#003a63",
  "HPU": "#330072",
  "Hampton Lady Pirates": "#0067ac",
  "Harvard Crimson": "#990000",
  "Hawai'i Rainbow Warriors": "#005737",
  "High Point Panthers": "#330072",
  "Hofstra Pride": "#003594",
  "Holy Cross Crusaders": "#582c83",
  "Houston Christian Huskies": "#00539c",
  "Houston Cougars": "#c8102e",
  "Howard Bison": "#003a63",
  "IDHO": "#000000",
  "IDST": "#ef8c00",
  "ILL": "#ff5f05",
  "ILST": "#ce1126",
  "INST": "#00669a",
  "IONA": "#6f2c3e",
  "IOWA": "#231f20",
  "ISU": "#ae192d",
  "IU": "#970310",
  "IU Indianapolis Jaguars": "#a81f30",
  "IUIN": "#a81f30",
  "Idaho State Bengals": "#ef8c00",
  "Idaho Vandals": "#000000",
  "Illinois Fighting Illini": "#ff5f05",
  "Illinois State Redbirds": "#ce1126",
  "Incarnate Word Cardinals": "#000000",
  "Indiana Hoosiers": "#970310",
  "Indiana State Sycamores": "#00669a",
  "Iona Gaels": "#6f2c3e",
  "Iowa Hawkeyes": "#231f20",
  "Iowa State Cyclones": "#ae192d",
  "JAX": "#00523e",
  "JKST": "#123297",
  "JMU": "#450084",
  "JOES": "#9e1b32",
  "JXST": "#cc0000",
  "Jackson State Lady Tigers": "#123297",
  "Jacksonville Dolphins": "#00523e",
  "Jacksonville State Gamecocks": "#cc0000",
  "James Madison Dukes": "#450084",
  "KC": "#004b87",
  "KENN": "#fdbb30",
  "KENT": "#002664",
  "KSU": "#330a57",
  "KU": "#0051ba",
  "Kansas City Roos": "#004b87",
  "Kansas Jayhawks": "#0051ba",
  "Kansas State Wildcats": "#330a57",
  "Kennesaw State Owls": "#fdbb30",
  "Kent State Golden Flashes": "#002664",
  "Kentucky Wildcats": "#0033a0",
  "L-MD": "#76a7a0",
  "LAF": "#790000",
  "LAM": "#000000",
  "LAS": "#003356",
  "LBSU": "#000000",
  "LEH": "#6c2b2a",
  "LEM": "#000000",
  "LIB": "#0a254e",
  "LIN": "#000000",
  "LIP": "#20366c",
  "LIU": "#50c9f7",
  "LMU": "#880029",
  "LONG": "#003273",
  "LOU": "#c9001f",
  "LR": "#ad0000",
  "LSU": "#461d76",
  "LSU New Orleans Privateers": "#005da6",
  "LSU Tigers": "#461d76",
  "LT": "#003087",
  "LUC": "#9d1244",
  "La Salle Explorers": "#003356",
  "Lafayette Leopards": "#790000",
  "Lamar Cardinals": "#000000",
  "Le Moyne Dolphins": "#000000",
  "Lehigh Mountain Hawks": "#6c2b2a",
  "Liberty Flames": "#0a254e",
  "Lindenwood Lions": "#000000",
  "Lipscomb Bisons": "#20366c",
  "Little Rock Trojans": "#ad0000",
  "Long Beach State Beach": "#000000",
  "Long Island University Sharks": "#50c9f7",
  "Longwood Lancers": "#003273",
  "Louisiana Ragin' Cajuns": "#ce181e",
  "Louisiana Tech Lady Techsters": "#003087",
  "Louisville Cardinals": "#c9001f",
  "Loyola Chicago Ramblers": "#9d1244",
  "Loyola Maryland Greyhounds": "#76a7a0",
  "Loyola Marymount Lions": "#880029",
  "M-OH": "#c41230",
  "MAN": "#4f8537",
  "MARQ": "#003366",
  "MASS": "#881c1c",
  "MCN": "#00529c",
  "MD": "#ce1126",
  "ME": "#127dbe",
  "MEM": "#004991",
  "MER": "#ff7f29",
  "MIA": "#f47423",
  "MICH": "#00274c",
  "MILW": "#000000",
  "MINN": "#5e0a2f",
  "MISS": "#13294b",
  "MIZ": "#f1b82d",
  "MONM": "#051844",
  "MONT": "#751d4a",
  "MORE": "#094fa3",
  "MORG": "#014786",
  "MOST": "#5e0009",
  "MRMK": "#2f4f93",
  "MRSH": "#00b140",
  "MRST": "#e53730",
  "MSM": "#005596",
  "MSST": "#5d1725",
  "MSU": "#173f35",
  "MTST": "#00205c",
  "MTSU": "#036eb7",
  "MUR": "#002148",
  "MVSU": "#005328",
  "Maine Black Bears": "#127dbe",
  "Manhattan Jaspers": "#4f8537",
  "Marist Red Foxes": "#e53730",
  "Marquette Golden Eagles": "#003366",
  "Marshall Thundering Herd": "#00b140",
  "Maryland Eastern Shore Hawks": "#5c2301",
  "Maryland Terrapins": "#ce1126",
  "Massachusetts Minutewomen": "#881c1c",
  "McNeese Cowgirls": "#00529c",
  "Memphis Tigers": "#004991",
  "Mercer Bears": "#ff7f29",
  "Merrimack Warriors": "#2f4f93",
  "Miami (OH) RedHawks": "#c41230",
  "Miami Hurricanes": "#f47423",
  "Michigan State Spartans": "#173f35",
  "Michigan Wolverines": "#00274c",
  "Middle Tennessee Blue Raiders": "#036eb7",
  "Milwaukee Panthers": "#000000",
  "Minnesota Golden Gophers": "#5e0a2f",
  "Mississippi State Bulldogs": "#5d1725",
  "Mississippi Valley State Devilettes": "#005328",
  "Missouri State Lady Bears": "#5e0009",
  "Missouri Tigers": "#f1b82d",
  "Monmouth Hawks": "#051844",
  "Montana Lady Griz": "#751d4a",
  "Montana State Bobcats": "#00205c",
  "Morehead State Eagles": "#094fa3",
  "Morgan State Lady Bears": "#014786",
  "Mount St. Mary's Mountaineers": "#005596",
  "Murray State Racers": "#002148",
  "NAU": "#003976",
  "NAVY": "#00225b",
  "NC State Wolfpack": "#cc0000",
  "NCAT": "#0505aa",
  "NCCU": "#880023",
  "NCSU": "#cc0000",
  "ND": "#062340",
  "NDSU": "#01402a",
  "NE": "#cc0001",
  "NEB": "#e31937",
  "NEV": "#041e42",
  "NHVN": "#041e42",
  "NIA": "#69207e",
  "NICH": "#c41230",
  "NIU": "#c8102e",
  "NJIT": "#ee3024",
  "NJIT Highlanders": "#ee3024",
  "NKU": "#ffc82e",
  "NMSU": "#7e141b",
  "NOLA": "#005da6",
  "NORF": "#0c8968",
  "NU": "#492f92",
  "NWST": "#492f91",
  "Navy Midshipmen": "#00225b",
  "Nebraska Cornhuskers": "#e31937",
  "Nevada Wolf Pack": "#041e42",
  "New Hampshire Wildcats": "#004990",
  "New Haven Chargers": "#041e42",
  "New Mexico Lobos": "#ba0c2f",
  "New Mexico State Aggies": "#7e141b",
  "Niagara Purple Eagles": "#69207e",
  "Nicholls Colonels": "#c41230",
  "Norfolk State Spartans": "#0c8968",
  "North Alabama Lions": "#000000",
  "North Carolina A&T Aggies": "#0505aa",
  "North Carolina Central Eagles": "#880023",
  "North Carolina Tar Heels": "#7bafd4",
  "North Dakota Fighting Hawks": "#00a26b",
  "North Dakota State Bison": "#01402a",
  "North Florida Ospreys": "#004b8d",
  "North Texas Mean Green": "#068f33",
  "Northeastern Huskies": "#cc0001",
  "Northern Arizona Lumberjacks": "#003976",
  "Northern Colorado Bears": "#13558d",
  "Northern Illinois Huskies": "#c8102e",
  "Northern Iowa Panthers": "#473282",
  "Northern Kentucky Norse": "#ffc82e",
  "Northwestern State Lady Demons": "#492f91",
  "Northwestern Wildcats": "#492f92",
  "Notre Dame Fighting Irish": "#062340",
  "OAK": "#04091c",
  "ODU": "#003768",
  "OHIO": "#154734",
  "OKST": "#fe5c00",
  "OMA": "#e3193e",
  "ORE": "#00934b",
  "ORST": "#dc4405",
  "ORU": "#002462",
  "OSU": "#ba0c2f",
  "OU": "#990000",
  "Oakland Golden Grizzlies": "#04091c",
  "Ohio Bobcats": "#154734",
  "Ohio State Buckeyes": "#ba0c2f",
  "Oklahoma Sooners": "#990000",
  "Oklahoma State Cowgirls": "#fe5c00",
  "Old Dominion Monarchs": "#003768",
  "Ole Miss Rebels": "#13294b",
  "Omaha Mavericks": "#e3193e",
  "Oral Roberts Golden Eagles": "#002462",
  "Oregon Ducks": "#00934b",
  "Oregon State Beavers": "#dc4405",
  "PAC": "#f47820",
  "PENN": "#082a74",
  "PEPP": "#003a72",
  "PFW": "#cfb991",
  "PITT": "#003594",
  "PORT": "#330072",
  "PRES": "#194896",
  "PRIN": "#000000",
  "PROV": "#000000",
  "PRST": "#00311e",
  "PSU": "#061440",
  "PUR": "#ceb888",
  "PV": "#582c83",
  "Pacific Tigers": "#f47820",
  "Penn State Lady Lions": "#061440",
  "Pennsylvania Quakers": "#082a74",
  "Pepperdine Waves": "#003a72",
  "Pittsburgh Panthers": "#003594",
  "Portland Pilots": "#330072",
  "Portland State Vikings": "#00311e",
  "Prairie View A&M Lady Panthers": "#582c83",
  "Presbyterian Blue Hose": "#194896",
  "Princeton Tigers": "#000000",
  "Providence Friars": "#000000",
  "Purdue Boilermakers": "#ceb888",
  "Purdue Fort Wayne Mastodons": "#cfb991",
  "QUC": "#192c66",
  "QUIN": "#041b43",
  "Queens University Royals": "#192c66",
  "Quinnipiac Bobcats": "#041b43",
  "RAD": "#bc1515",
  "RGV": "#dc6000",
  "RICE": "#00205b",
  "RICH": "#9e0712",
  "RID": "#a80532",
  "RMU": "#00214d",
  "RUTG": "#ce0e2d",
  "Radford Highlanders": "#bc1515",
  "Rhode Island Rams": "#091f3f",
  "Rice Owls": "#00205b",
  "Richmond Spiders": "#9e0712",
  "Rider Broncs": "#a80532",
  "Robert Morris Colonials": "#00214d",
  "Rutgers Scarlet Knights": "#ce0e2d",
  "SAC": "#00573c",
  "SAM": "#005485",
  "SBU": "#70261d",
  "SC": "#73000a",
  "SCST": "#7d1315",
  "SCU": "#690b0b",
  "SDAK": "#cd1241",
  "SDST": "#0033a0",
  "SDSU": "#a6192e",
  "SE Louisiana Lady Lions": "#215732",
  "SEA": "#bf2e1a",
  "SELA": "#215732",
  "SEMO": "#c8102e",
  "SF": "#005a36",
  "SFA": "#393996",
  "SHSU": "#f56423",
  "SHU": "#a40012",
  "SIE": "#037961",
  "SIU": "#85283d",
  "SIU Edwardsville Cougars": "#eb1c23",
  "SIUE": "#eb1c23",
  "SJSU": "#0038a8",
  "SJU": "#d10000",
  "SLU": "#00539c",
  "SMC": "#d80024",
  "SMU": "#a80000",
  "SMU Mustangs": "#a80000",
  "SOU": "#004b97",
  "SPU": "#004cc2",
  "STAN": "#8c1515",
  "STBK": "#990000",
  "STET": "#0a5640",
  "STMN": "#000000",
  "STO": "#000000",
  "SUU": "#c72026",
  "SYR": "#000e54",
  "Sacramento State Hornets": "#00573c",
  "Sacred Heart Pioneers": "#a40012",
  "Saint Joseph's Hawks": "#9e1b32",
  "Saint Louis Billikens": "#00539c",
  "Saint Mary's Gaels": "#d80024",
  "Saint Peter's Peacocks": "#004cc2",
  "Sam Houston Bearkats": "#f56423",
  "Samford Bulldogs": "#005485",
  "San Diego State Aztecs": "#a6192e",
  "San Diego Toreros": "#2f99d4",
  "San Francisco Dons": "#005a36",
  "San José State Spartans": "#0038a8",
  "Santa Clara Broncos": "#690b0b",
  "Seattle U Redhawks": "#bf2e1a",
  "Seton Hall Pirates": "#0857b1",
  "Siena Saints": "#037961",
  "South Alabama Jaguars": "#00205b",
  "South Carolina Gamecocks": "#73000a",
  "South Carolina State Lady Bulldogs": "#7d1315",
  "South Carolina Upstate Spartans": "#008545",
  "South Dakota Coyotes": "#cd1241",
  "South Dakota State Jackrabbits": "#0033a0",
  "South Florida Bulls": "#006747",
  "Southeast Missouri State Redhawks": "#c8102e",
  "Southern Illinois Salukis": "#85283d",
  "Southern Indiana Screaming Eagles": "#000000",
  "Southern Jaguars": "#004b97",
  "Southern Miss Lady Eagles": "#ffc72c",
  "Southern Utah Thunderbirds": "#c72026",
  "St. Bonaventure Bonnies": "#70261d",
  "St. John's Red Storm": "#d10000",
  "St. Thomas Tommies": "#000000",
  "Stanford Cardinal": "#8c1515",
  "Stephen F. Austin Ladyjacks": "#393996",
  "Stetson Hatters": "#0a5640",
  "Stonehill Skyhawks": "#000000",
  "Stony Brook Seawolves": "#990000",
  "Syracuse Orange": "#000e54",
  "TA&M": "#500000",
  "TAR": "#000000",
  "TCU": "#4d1979",
  "TCU Horned Frogs": "#4d1979",
  "TEM": "#a41e35",
  "TENN": "#ff8200",
  "TEX": "#af5c37",
  "TLSA": "#003595",
  "TNST": "#171796",
  "TNTC": "#5a4099",
  "TOL": "#0b2240",
  "TOW": "#ffc229",
  "TROY": "#862633",
  "TTU": "#da291c",
  "TULN": "#006747",
  "TXSO": "#860038",
  "TXST": "#501214",
  "Tarleton State Texans": "#000000",
  "Temple Owls": "#a41e35",
  "Tennessee Lady Volunteers": "#ff8200",
  "Tennessee State Lady Tigers": "#171796",
  "Tennessee Tech Golden Eagles": "#5a4099",
  "Texas A&M Aggies": "#500000",
  "Texas A&M-Corpus Christi Islanders": "#0067c5",
  "Texas Longhorns": "#af5c37",
  "Texas Southern Tigers": "#860038",
  "Texas State Bobcats": "#501214",
  "Texas Tech Lady Raiders": "#da291c",
  "Toledo Rockets": "#0b2240",
  "Towson Tigers": "#ffc229",
  "Troy Trojans": "#862633",
  "Tulane Green Wave": "#006747",
  "Tulsa Golden Hurricane": "#003595",
  "UAB": "#1a5632",
  "UAB Blazers": "#1a5632",
  "UALB": "#3d2777",
  "UAPB": "#e0aa0f",
  "UAlbany Great Danes": "#3d2777",
  "UC Davis Aggies": "#002855",
  "UC Irvine Anteaters": "#002b5c",
  "UC Riverside Highlanders": "#14234f",
  "UC San Diego Tritons": "#000000",
  "UC Santa Barbara Gauchos": "#1e1840",
  "UCD": "#002855",
  "UCF": "#000000",
  "UCF Knights": "#000000",
  "UCI": "#002b5c",
  "UCLA": "#2774ae",
  "UCLA Bruins": "#2774ae",
  "UCR": "#14234f",
  "UCSB": "#1e1840",
  "UCSD": "#000000",
  "UConn Huskies": "#0c2340",
  "UGA": "#ba0c2f",
  "UIC": "#001e62",
  "UIC Flames": "#001e62",
  "UIW": "#000000",
  "UK": "#0033a0",
  "UL": "#ce181e",
  "UL Monroe Warhawks": "#840029",
  "ULM": "#840029",
  "UMBC": "#000000",
  "UMBC Retrievers": "#000000",
  "UMES": "#5c2301",
  "UML": "#000000",
  "UMass Lowell River Hawks": "#000000",
  "UNA": "#000000",
  "UNC": "#7bafd4",
  "UNC Asheville Bulldogs": "#003da5",
  "UNC Greensboro Spartans": "#003559",
  "UNC Wilmington Seahawks": "#00665e",
  "UNCA": "#003da5",
  "UNCG": "#003559",
  "UNCO": "#13558d",
  "UNCW": "#00665e",
  "UND": "#00a26b",
  "UNF": "#004b8d",
  "UNH": "#004990",
  "UNI": "#473282",
  "UNLV": "#cf0a2c",
  "UNLV Lady Rebels": "#cf0a2c",
  "UNM": "#ba0c2f",
  "UNT": "#068f33",
  "UPST": "#008545",
  "URI": "#091f3f",
  "USA": "#00205b",
  "USC": "#9d2235",
  "USC Trojans": "#9d2235",
  "USD": "#2f99d4",
  "USF": "#006747",
  "USI": "#000000",
  "USM": "#ffc72c",
  "USU": "#0f2439",
  "UT Arlington Mavericks": "#004b7c",
  "UT Martin Skyhawks": "#ff6700",
  "UT Rio Grande Valley Vaqueros": "#dc6000",
  "UTA": "#004b7c",
  "UTAH": "#be0000",
  "UTC": "#00386b",
  "UTEP": "#ff8200",
  "UTEP Miners": "#ff8200",
  "UTM": "#ff6700",
  "UTSA": "#0c2340",
  "UTSA Roadrunners": "#0c2340",
  "UTU": "#000000",
  "UVA": "#232d4b",
  "UVM": "#154734",
  "UVU": "#004812",
  "Utah State Aggies": "#0f2439",
  "Utah Tech Trailblazers": "#000000",
  "Utah Utes": "#be0000",
  "Utah Valley Wolverines": "#004812",
  "VAL": "#794500",
  "VAN": "#000000",
  "VCU": "#ffaf00",
  "VCU Rams": "#ffaf00",
  "VILL": "#00205b",
  "VT": "#6a2c3e",
  "Valparaiso Beacons": "#794500",
  "Vanderbilt Commodores": "#000000",
  "Vermont Catamounts": "#154734",
  "Villanova Wildcats": "#00205b",
  "Virginia Cavaliers": "#232d4b",
  "Virginia Tech Hokies": "#6a2c3e",
  "W&M": "#115740",
  "WAG": "#00483a",
  "WAKE": "#ceb888",
  "WASH": "#33006f",
  "WCU": "#492f91",
  "WEB": "#18005a",
  "WFL": "#087dc2",
  "WGA": "#0033a1",
  "WICH": "#ffcd00",
  "WIN": "#9e0b0e",
  "WIS": "#a00000",
  "WIU": "#4e1e8a",
  "WKU": "#e13a3e",
  "WMU": "#532e1f",
  "WOF": "#533b24",
  "WRST": "#cba052",
  "WSU": "#a60f2d",
  "WVU": "#eaaa00",
  "WYO": "#492f24",
  "Wagner Seahawks": "#00483a",
  "Wake Forest Demon Deacons": "#ceb888",
  "Washington Huskies": "#33006f",
  "Washington State Cougars": "#a60f2d",
  "Weber State Wildcats": "#18005a",
  "West Florida Argonauts": "#087dc2",
  "West Georgia Wolves": "#0033a1",
  "West Virginia Mountaineers": "#eaaa00",
  "Western Carolina Catamounts": "#492f91",
  "Western Illinois Leathernecks": "#4e1e8a",
  "Western Kentucky Lady Toppers": "#e13a3e",
  "Western Michigan Broncos": "#532e1f",
  "Wichita State Shockers": "#ffcd00",
  "William & Mary Tribe": "#115740",
  "Winthrop Eagles": "#9e0b0e",
  "Wisconsin Badgers": "#a00000",
  "Wofford Terriers": "#533b24",
  "Wright State Raiders": "#cba052",
  "Wyoming Cowgirls": "#492f24",
  "XAV": "#21304e",
  "Xavier Musketeers": "#21304e",
  "YALE": "#004a81",
  "YSU": "#e51937",
  "Yale Bulldogs": "#004a81",
  "Youngstown State Penguins": "#e51937",
}

// Sport key → color map. Same short + full key patterns as teamLogos.js
// so callers can pass either the app's short sport ('nfl') or a full
// odds-API key ('americanfootball_nfl').
const SPORT_MAP = {
  nfl: NFL_COLORS, americanfootball_nfl: NFL_COLORS,
  americanfootball_nfl_preseason: NFL_COLORS,
  nba: NBA_COLORS, basketball_nba: NBA_COLORS,
  wnba: WNBA_COLORS, basketball_wnba: WNBA_COLORS,
  mlb: MLB_COLORS, baseball_mlb: MLB_COLORS,
  nhl: NHL_COLORS, icehockey_nhl: NHL_COLORS,
  mls: MLS_COLORS, soccer_usa_mls: MLS_COLORS,
  ufl: UFL_COLORS, americanfootball_ufl: UFL_COLORS,
  ncaaf: NCAAF_COLORS, americanfootball_ncaaf: NCAAF_COLORS,
  ncaab: NCAAB_COLORS, basketball_ncaab: NCAAB_COLORS,
  wncaab: WNCAAB_COLORS, basketball_wncaab: WNCAAB_COLORS,
}

// Strip diacritics, straighten quotes, lowercase. Bridges name mismatches
// between odds sources ("San Jose State") and ESPN ("San José State").
function normalizeName(s) {
  if (!s) return ''
  return s
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/[ʻʼ‘’]/g, "'")
    .replace(/'/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase()
}

const _normCache = new WeakMap()
function normalizedLookup(map, teamName) {
  if (!map || !teamName) return null
  if (map[teamName] != null) return map[teamName]
  let cached = _normCache.get(map)
  if (!cached) {
    cached = {}
    for (const k of Object.keys(map)) cached[normalizeName(k)] = map[k]
    _normCache.set(map, cached)
  }
  return cached[normalizeName(teamName)] ?? null
}

// Look up a team's primary color by sport + team name OR abbreviation.
// Returns a #rrggbb string or null when the sport/team isn't covered.
// Pure black (#000000) is preserved — some teams (Raiders, Bruins) do
// use it, and callers can choose their own fallback for that case.
export function getTeamColor(sportKey, team) {
  if (!sportKey || !team) return null
  const map = SPORT_MAP[sportKey]
  if (!map) return null
  return normalizedLookup(map, team)
}
